var cov_2bpe87ftbo = function () {
  var path = "/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/portfolio/portfolioCtrl.js",
      hash = "d37c0d6e3f871f8bce23eae83cf47453a1061d29",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/portfolio/portfolioCtrl.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 669,
          column: 3
        }
      },
      "1": {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "2": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 6,
          column: 5
        }
      },
      "3": {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 49
        }
      },
      "4": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 37
        }
      },
      "5": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "6": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 11,
          column: 3
        }
      },
      "7": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 45
        }
      },
      "8": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 48
        }
      },
      "9": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 34
        }
      },
      "10": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 572,
          column: 4
        }
      },
      "11": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 41
        }
      },
      "12": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 36,
          column: 7
        }
      },
      "13": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 35,
          column: 9
        }
      },
      "14": {
        start: {
          line: 34,
          column: 10
        },
        end: {
          line: 34,
          column: 23
        }
      },
      "15": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 18
        }
      },
      "16": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 285,
          column: 46
        }
      },
      "17": {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 290,
          column: 7
        }
      },
      "18": {
        start: {
          line: 289,
          column: 8
        },
        end: {
          line: 289,
          column: 15
        }
      },
      "19": {
        start: {
          line: 291,
          column: 6
        },
        end: {
          line: 291,
          column: 56
        }
      },
      "20": {
        start: {
          line: 294,
          column: 6
        },
        end: {
          line: 294,
          column: 39
        }
      },
      "21": {
        start: {
          line: 296,
          column: 6
        },
        end: {
          line: 296,
          column: 36
        }
      },
      "22": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 299,
          column: 7
        }
      },
      "23": {
        start: {
          line: 298,
          column: 8
        },
        end: {
          line: 298,
          column: 15
        }
      },
      "24": {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 300,
          column: 49
        }
      },
      "25": {
        start: {
          line: 301,
          column: 6
        },
        end: {
          line: 301,
          column: 61
        }
      },
      "26": {
        start: {
          line: 302,
          column: 6
        },
        end: {
          line: 302,
          column: 42
        }
      },
      "27": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 304,
          column: 34
        }
      },
      "28": {
        start: {
          line: 307,
          column: 6
        },
        end: {
          line: 323,
          column: 9
        }
      },
      "29": {
        start: {
          line: 308,
          column: 8
        },
        end: {
          line: 308,
          column: 47
        }
      },
      "30": {
        start: {
          line: 309,
          column: 8
        },
        end: {
          line: 322,
          column: 9
        }
      },
      "31": {
        start: {
          line: 310,
          column: 10
        },
        end: {
          line: 316,
          column: 11
        }
      },
      "32": {
        start: {
          line: 311,
          column: 12
        },
        end: {
          line: 311,
          column: 52
        }
      },
      "33": {
        start: {
          line: 312,
          column: 12
        },
        end: {
          line: 312,
          column: 52
        }
      },
      "34": {
        start: {
          line: 313,
          column: 12
        },
        end: {
          line: 313,
          column: 52
        }
      },
      "35": {
        start: {
          line: 314,
          column: 12
        },
        end: {
          line: 314,
          column: 52
        }
      },
      "36": {
        start: {
          line: 315,
          column: 12
        },
        end: {
          line: 315,
          column: 52
        }
      },
      "37": {
        start: {
          line: 317,
          column: 10
        },
        end: {
          line: 321,
          column: 11
        }
      },
      "38": {
        start: {
          line: 318,
          column: 12
        },
        end: {
          line: 318,
          column: 55
        }
      },
      "39": {
        start: {
          line: 320,
          column: 12
        },
        end: {
          line: 320,
          column: 72
        }
      },
      "40": {
        start: {
          line: 326,
          column: 19
        },
        end: {
          line: 326,
          column: 42
        }
      },
      "41": {
        start: {
          line: 327,
          column: 22
        },
        end: {
          line: 327,
          column: 24
        }
      },
      "42": {
        start: {
          line: 328,
          column: 6
        },
        end: {
          line: 354,
          column: 7
        }
      },
      "43": {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 332,
          column: 11
        }
      },
      "44": {
        start: {
          line: 331,
          column: 10
        },
        end: {
          line: 331,
          column: 85
        }
      },
      "45": {
        start: {
          line: 334,
          column: 8
        },
        end: {
          line: 336,
          column: 11
        }
      },
      "46": {
        start: {
          line: 335,
          column: 10
        },
        end: {
          line: 335,
          column: 44
        }
      },
      "47": {
        start: {
          line: 338,
          column: 8
        },
        end: {
          line: 349,
          column: 11
        }
      },
      "48": {
        start: {
          line: 339,
          column: 25
        },
        end: {
          line: 339,
          column: 53
        }
      },
      "49": {
        start: {
          line: 341,
          column: 10
        },
        end: {
          line: 346,
          column: 11
        }
      },
      "50": {
        start: {
          line: 342,
          column: 12
        },
        end: {
          line: 342,
          column: 72
        }
      },
      "51": {
        start: {
          line: 343,
          column: 12
        },
        end: {
          line: 343,
          column: 35
        }
      },
      "52": {
        start: {
          line: 345,
          column: 12
        },
        end: {
          line: 345,
          column: 54
        }
      },
      "53": {
        start: {
          line: 348,
          column: 10
        },
        end: {
          line: 348,
          column: 70
        }
      },
      "54": {
        start: {
          line: 356,
          column: 6
        },
        end: {
          line: 356,
          column: 18
        }
      },
      "55": {
        start: {
          line: 359,
          column: 19
        },
        end: {
          line: 359,
          column: 33
        }
      },
      "56": {
        start: {
          line: 360,
          column: 6
        },
        end: {
          line: 360,
          column: 43
        }
      },
      "57": {
        start: {
          line: 361,
          column: 6
        },
        end: {
          line: 419,
          column: 9
        }
      },
      "58": {
        start: {
          line: 423,
          column: 6
        },
        end: {
          line: 423,
          column: 45
        }
      },
      "59": {
        start: {
          line: 424,
          column: 6
        },
        end: {
          line: 424,
          column: 62
        }
      },
      "60": {
        start: {
          line: 425,
          column: 6
        },
        end: {
          line: 425,
          column: 59
        }
      },
      "61": {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 426,
          column: 59
        }
      },
      "62": {
        start: {
          line: 427,
          column: 6
        },
        end: {
          line: 427,
          column: 66
        }
      },
      "63": {
        start: {
          line: 428,
          column: 6
        },
        end: {
          line: 428,
          column: 49
        }
      },
      "64": {
        start: {
          line: 430,
          column: 6
        },
        end: {
          line: 432,
          column: 21
        }
      },
      "65": {
        start: {
          line: 431,
          column: 15
        },
        end: {
          line: 431,
          column: 39
        }
      },
      "66": {
        start: {
          line: 435,
          column: 6
        },
        end: {
          line: 438,
          column: 9
        }
      },
      "67": {
        start: {
          line: 436,
          column: 8
        },
        end: {
          line: 436,
          column: 49
        }
      },
      "68": {
        start: {
          line: 437,
          column: 8
        },
        end: {
          line: 437,
          column: 37
        }
      },
      "69": {
        start: {
          line: 440,
          column: 6
        },
        end: {
          line: 442,
          column: 9
        }
      },
      "70": {
        start: {
          line: 441,
          column: 8
        },
        end: {
          line: 441,
          column: 37
        }
      },
      "71": {
        start: {
          line: 444,
          column: 6
        },
        end: {
          line: 451,
          column: 9
        }
      },
      "72": {
        start: {
          line: 456,
          column: 6
        },
        end: {
          line: 456,
          column: 26
        }
      },
      "73": {
        start: {
          line: 458,
          column: 8
        },
        end: {
          line: 458,
          column: 65
        }
      },
      "74": {
        start: {
          line: 460,
          column: 6
        },
        end: {
          line: 517,
          column: 9
        }
      },
      "75": {
        start: {
          line: 463,
          column: 21
        },
        end: {
          line: 463,
          column: 42
        }
      },
      "76": {
        start: {
          line: 492,
          column: 8
        },
        end: {
          line: 501,
          column: 11
        }
      },
      "77": {
        start: {
          line: 493,
          column: 10
        },
        end: {
          line: 496,
          column: 12
        }
      },
      "78": {
        start: {
          line: 497,
          column: 10
        },
        end: {
          line: 497,
          column: 74
        }
      },
      "79": {
        start: {
          line: 498,
          column: 10
        },
        end: {
          line: 498,
          column: 74
        }
      },
      "80": {
        start: {
          line: 499,
          column: 10
        },
        end: {
          line: 499,
          column: 66
        }
      },
      "81": {
        start: {
          line: 500,
          column: 10
        },
        end: {
          line: 500,
          column: 25
        }
      },
      "82": {
        start: {
          line: 506,
          column: 32
        },
        end: {
          line: 508,
          column: 10
        }
      },
      "83": {
        start: {
          line: 507,
          column: 10
        },
        end: {
          line: 507,
          column: 33
        }
      },
      "84": {
        start: {
          line: 509,
          column: 8
        },
        end: {
          line: 509,
          column: 37
        }
      },
      "85": {
        start: {
          line: 510,
          column: 26
        },
        end: {
          line: 510,
          column: 162
        }
      },
      "86": {
        start: {
          line: 511,
          column: 8
        },
        end: {
          line: 515,
          column: 9
        }
      },
      "87": {
        start: {
          line: 512,
          column: 10
        },
        end: {
          line: 512,
          column: 57
        }
      },
      "88": {
        start: {
          line: 513,
          column: 10
        },
        end: {
          line: 513,
          column: 60
        }
      },
      "89": {
        start: {
          line: 514,
          column: 10
        },
        end: {
          line: 514,
          column: 17
        }
      },
      "90": {
        start: {
          line: 516,
          column: 8
        },
        end: {
          line: 516,
          column: 29
        }
      },
      "91": {
        start: {
          line: 520,
          column: 6
        },
        end: {
          line: 526,
          column: 8
        }
      },
      "92": {
        start: {
          line: 524,
          column: 10
        },
        end: {
          line: 524,
          column: 31
        }
      },
      "93": {
        start: {
          line: 530,
          column: 6
        },
        end: {
          line: 562,
          column: 8
        }
      },
      "94": {
        start: {
          line: 542,
          column: 10
        },
        end: {
          line: 544,
          column: 11
        }
      },
      "95": {
        start: {
          line: 543,
          column: 12
        },
        end: {
          line: 543,
          column: 19
        }
      },
      "96": {
        start: {
          line: 545,
          column: 10
        },
        end: {
          line: 545,
          column: 34
        }
      },
      "97": {
        start: {
          line: 546,
          column: 10
        },
        end: {
          line: 560,
          column: 12
        }
      },
      "98": {
        start: {
          line: 550,
          column: 14
        },
        end: {
          line: 557,
          column: 15
        }
      },
      "99": {
        start: {
          line: 551,
          column: 16
        },
        end: {
          line: 554,
          column: 19
        }
      },
      "100": {
        start: {
          line: 555,
          column: 16
        },
        end: {
          line: 555,
          column: 41
        }
      },
      "101": {
        start: {
          line: 556,
          column: 16
        },
        end: {
          line: 556,
          column: 23
        }
      },
      "102": {
        start: {
          line: 558,
          column: 14
        },
        end: {
          line: 558,
          column: 35
        }
      },
      "103": {
        start: {
          line: 565,
          column: 6
        },
        end: {
          line: 565,
          column: 31
        }
      },
      "104": {
        start: {
          line: 566,
          column: 6
        },
        end: {
          line: 566,
          column: 27
        }
      },
      "105": {
        start: {
          line: 569,
          column: 6
        },
        end: {
          line: 569,
          column: 26
        }
      },
      "106": {
        start: {
          line: 570,
          column: 6
        },
        end: {
          line: 570,
          column: 39
        }
      },
      "107": {
        start: {
          line: 574,
          column: 20
        },
        end: {
          line: 584,
          column: 4
        }
      },
      "108": {
        start: {
          line: 586,
          column: 2
        },
        end: {
          line: 591,
          column: 4
        }
      },
      "109": {
        start: {
          line: 587,
          column: 4
        },
        end: {
          line: 588,
          column: 68
        }
      },
      "110": {
        start: {
          line: 589,
          column: 4
        },
        end: {
          line: 589,
          column: 28
        }
      },
      "111": {
        start: {
          line: 590,
          column: 4
        },
        end: {
          line: 590,
          column: 22
        }
      },
      "112": {
        start: {
          line: 593,
          column: 2
        },
        end: {
          line: 606,
          column: 4
        }
      },
      "113": {
        start: {
          line: 594,
          column: 4
        },
        end: {
          line: 594,
          column: 41
        }
      },
      "114": {
        start: {
          line: 595,
          column: 4
        },
        end: {
          line: 603,
          column: 5
        }
      },
      "115": {
        start: {
          line: 596,
          column: 6
        },
        end: {
          line: 602,
          column: 7
        }
      },
      "116": {
        start: {
          line: 597,
          column: 8
        },
        end: {
          line: 600,
          column: 10
        }
      },
      "117": {
        start: {
          line: 601,
          column: 8
        },
        end: {
          line: 601,
          column: 14
        }
      },
      "118": {
        start: {
          line: 604,
          column: 4
        },
        end: {
          line: 604,
          column: 46
        }
      },
      "119": {
        start: {
          line: 605,
          column: 4
        },
        end: {
          line: 605,
          column: 29
        }
      },
      "120": {
        start: {
          line: 609,
          column: 2
        },
        end: {
          line: 625,
          column: 5
        }
      },
      "121": {
        start: {
          line: 610,
          column: 4
        },
        end: {
          line: 610,
          column: 56
        }
      },
      "122": {
        start: {
          line: 611,
          column: 4
        },
        end: {
          line: 616,
          column: 5
        }
      },
      "123": {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 614,
          column: 9
        }
      },
      "124": {
        start: {
          line: 613,
          column: 8
        },
        end: {
          line: 613,
          column: 42
        }
      },
      "125": {
        start: {
          line: 615,
          column: 6
        },
        end: {
          line: 615,
          column: 13
        }
      },
      "126": {
        start: {
          line: 617,
          column: 4
        },
        end: {
          line: 623,
          column: 5
        }
      },
      "127": {
        start: {
          line: 618,
          column: 6
        },
        end: {
          line: 622,
          column: 7
        }
      },
      "128": {
        start: {
          line: 619,
          column: 8
        },
        end: {
          line: 619,
          column: 38
        }
      },
      "129": {
        start: {
          line: 620,
          column: 8
        },
        end: {
          line: 620,
          column: 40
        }
      },
      "130": {
        start: {
          line: 621,
          column: 8
        },
        end: {
          line: 621,
          column: 15
        }
      },
      "131": {
        start: {
          line: 624,
          column: 4
        },
        end: {
          line: 624,
          column: 37
        }
      },
      "132": {
        start: {
          line: 627,
          column: 2
        },
        end: {
          line: 643,
          column: 5
        }
      },
      "133": {
        start: {
          line: 628,
          column: 4
        },
        end: {
          line: 628,
          column: 56
        }
      },
      "134": {
        start: {
          line: 629,
          column: 4
        },
        end: {
          line: 634,
          column: 5
        }
      },
      "135": {
        start: {
          line: 630,
          column: 6
        },
        end: {
          line: 632,
          column: 9
        }
      },
      "136": {
        start: {
          line: 631,
          column: 8
        },
        end: {
          line: 631,
          column: 42
        }
      },
      "137": {
        start: {
          line: 633,
          column: 6
        },
        end: {
          line: 633,
          column: 13
        }
      },
      "138": {
        start: {
          line: 635,
          column: 4
        },
        end: {
          line: 641,
          column: 5
        }
      },
      "139": {
        start: {
          line: 636,
          column: 6
        },
        end: {
          line: 640,
          column: 7
        }
      },
      "140": {
        start: {
          line: 637,
          column: 8
        },
        end: {
          line: 637,
          column: 38
        }
      },
      "141": {
        start: {
          line: 638,
          column: 8
        },
        end: {
          line: 638,
          column: 40
        }
      },
      "142": {
        start: {
          line: 639,
          column: 8
        },
        end: {
          line: 639,
          column: 15
        }
      },
      "143": {
        start: {
          line: 642,
          column: 4
        },
        end: {
          line: 642,
          column: 37
        }
      },
      "144": {
        start: {
          line: 646,
          column: 2
        },
        end: {
          line: 655,
          column: 4
        }
      },
      "145": {
        start: {
          line: 647,
          column: 4
        },
        end: {
          line: 654,
          column: 7
        }
      },
      "146": {
        start: {
          line: 657,
          column: 2
        },
        end: {
          line: 666,
          column: 4
        }
      },
      "147": {
        start: {
          line: 658,
          column: 4
        },
        end: {
          line: 665,
          column: 7
        }
      },
      "148": {
        start: {
          line: 668,
          column: 2
        },
        end: {
          line: 668,
          column: 23
        }
      },
      "149": {
        start: {
          line: 672,
          column: 15
        },
        end: {
          line: 672,
          column: 23
        }
      },
      "150": {
        start: {
          line: 674,
          column: 2
        },
        end: {
          line: 674,
          column: 41
        }
      },
      "151": {
        start: {
          line: 675,
          column: 2
        },
        end: {
          line: 687,
          column: 5
        }
      },
      "152": {
        start: {
          line: 676,
          column: 4
        },
        end: {
          line: 686,
          column: 6
        }
      },
      "153": {
        start: {
          line: 684,
          column: 8
        },
        end: {
          line: 684,
          column: 20
        }
      },
      "154": {
        start: {
          line: 689,
          column: 2
        },
        end: {
          line: 689,
          column: 24
        }
      },
      "155": {
        start: {
          line: 691,
          column: 2
        },
        end: {
          line: 713,
          column: 4
        }
      },
      "156": {
        start: {
          line: 697,
          column: 6
        },
        end: {
          line: 702,
          column: 7
        }
      },
      "157": {
        start: {
          line: 698,
          column: 8
        },
        end: {
          line: 698,
          column: 54
        }
      },
      "158": {
        start: {
          line: 699,
          column: 8
        },
        end: {
          line: 699,
          column: 50
        }
      },
      "159": {
        start: {
          line: 700,
          column: 8
        },
        end: {
          line: 700,
          column: 77
        }
      },
      "160": {
        start: {
          line: 701,
          column: 8
        },
        end: {
          line: 701,
          column: 73
        }
      },
      "161": {
        start: {
          line: 704,
          column: 6
        },
        end: {
          line: 709,
          column: 7
        }
      },
      "162": {
        start: {
          line: 705,
          column: 8
        },
        end: {
          line: 705,
          column: 54
        }
      },
      "163": {
        start: {
          line: 706,
          column: 8
        },
        end: {
          line: 706,
          column: 50
        }
      },
      "164": {
        start: {
          line: 707,
          column: 8
        },
        end: {
          line: 707,
          column: 77
        }
      },
      "165": {
        start: {
          line: 708,
          column: 8
        },
        end: {
          line: 708,
          column: 73
        }
      },
      "166": {
        start: {
          line: 711,
          column: 6
        },
        end: {
          line: 711,
          column: 30
        }
      },
      "167": {
        start: {
          line: 715,
          column: 2
        },
        end: {
          line: 783,
          column: 4
        }
      },
      "168": {
        start: {
          line: 716,
          column: 4
        },
        end: {
          line: 716,
          column: 37
        }
      },
      "169": {
        start: {
          line: 717,
          column: 17
        },
        end: {
          line: 717,
          column: 55
        }
      },
      "170": {
        start: {
          line: 719,
          column: 4
        },
        end: {
          line: 719,
          column: 66
        }
      },
      "171": {
        start: {
          line: 720,
          column: 18
        },
        end: {
          line: 722,
          column: 6
        }
      },
      "172": {
        start: {
          line: 721,
          column: 6
        },
        end: {
          line: 721,
          column: 77
        }
      },
      "173": {
        start: {
          line: 724,
          column: 4
        },
        end: {
          line: 727,
          column: 5
        }
      },
      "174": {
        start: {
          line: 725,
          column: 6
        },
        end: {
          line: 725,
          column: 33
        }
      },
      "175": {
        start: {
          line: 726,
          column: 6
        },
        end: {
          line: 726,
          column: 13
        }
      },
      "176": {
        start: {
          line: 761,
          column: 4
        },
        end: {
          line: 764,
          column: 6
        }
      },
      "177": {
        start: {
          line: 765,
          column: 4
        },
        end: {
          line: 768,
          column: 6
        }
      },
      "178": {
        start: {
          line: 769,
          column: 4
        },
        end: {
          line: 769,
          column: 67
        }
      },
      "179": {
        start: {
          line: 770,
          column: 4
        },
        end: {
          line: 770,
          column: 43
        }
      },
      "180": {
        start: {
          line: 771,
          column: 4
        },
        end: {
          line: 771,
          column: 60
        }
      },
      "181": {
        start: {
          line: 772,
          column: 4
        },
        end: {
          line: 772,
          column: 64
        }
      },
      "182": {
        start: {
          line: 773,
          column: 4
        },
        end: {
          line: 773,
          column: 64
        }
      },
      "183": {
        start: {
          line: 774,
          column: 4
        },
        end: {
          line: 774,
          column: 64
        }
      },
      "184": {
        start: {
          line: 775,
          column: 4
        },
        end: {
          line: 782,
          column: 6
        }
      },
      "185": {
        start: {
          line: 779,
          column: 8
        },
        end: {
          line: 779,
          column: 29
        }
      },
      "186": {
        start: {
          line: 780,
          column: 8
        },
        end: {
          line: 780,
          column: 28
        }
      },
      "187": {
        start: {
          line: 784,
          column: 2
        },
        end: {
          line: 786,
          column: 4
        }
      },
      "188": {
        start: {
          line: 785,
          column: 4
        },
        end: {
          line: 785,
          column: 40
        }
      },
      "189": {
        start: {
          line: 790,
          column: 2
        },
        end: {
          line: 795,
          column: 4
        }
      },
      "190": {
        start: {
          line: 791,
          column: 4
        },
        end: {
          line: 794,
          column: 7
        }
      },
      "191": {
        start: {
          line: 797,
          column: 2
        },
        end: {
          line: 800,
          column: 4
        }
      },
      "192": {
        start: {
          line: 798,
          column: 4
        },
        end: {
          line: 798,
          column: 28
        }
      },
      "193": {
        start: {
          line: 799,
          column: 4
        },
        end: {
          line: 799,
          column: 49
        }
      },
      "194": {
        start: {
          line: 802,
          column: 2
        },
        end: {
          line: 804,
          column: 5
        }
      },
      "195": {
        start: {
          line: 803,
          column: 4
        },
        end: {
          line: 803,
          column: 35
        }
      },
      "196": {
        start: {
          line: 806,
          column: 2
        },
        end: {
          line: 839,
          column: 4
        }
      },
      "197": {
        start: {
          line: 807,
          column: 4
        },
        end: {
          line: 807,
          column: 27
        }
      },
      "198": {
        start: {
          line: 808,
          column: 4
        },
        end: {
          line: 808,
          column: 31
        }
      },
      "199": {
        start: {
          line: 810,
          column: 4
        },
        end: {
          line: 814,
          column: 5
        }
      },
      "200": {
        start: {
          line: 811,
          column: 6
        },
        end: {
          line: 811,
          column: 90
        }
      },
      "201": {
        start: {
          line: 813,
          column: 6
        },
        end: {
          line: 813,
          column: 33
        }
      },
      "202": {
        start: {
          line: 817,
          column: 4
        },
        end: {
          line: 820,
          column: 5
        }
      },
      "203": {
        start: {
          line: 818,
          column: 6
        },
        end: {
          line: 818,
          column: 36
        }
      },
      "204": {
        start: {
          line: 819,
          column: 6
        },
        end: {
          line: 819,
          column: 13
        }
      },
      "205": {
        start: {
          line: 823,
          column: 4
        },
        end: {
          line: 829,
          column: 5
        }
      },
      "206": {
        start: {
          line: 824,
          column: 8
        },
        end: {
          line: 825,
          column: 60
        }
      },
      "207": {
        start: {
          line: 827,
          column: 8
        },
        end: {
          line: 827,
          column: 38
        }
      },
      "208": {
        start: {
          line: 828,
          column: 8
        },
        end: {
          line: 828,
          column: 15
        }
      },
      "209": {
        start: {
          line: 831,
          column: 4
        },
        end: {
          line: 838,
          column: 7
        }
      },
      "210": {
        start: {
          line: 835,
          column: 8
        },
        end: {
          line: 835,
          column: 64
        }
      },
      "211": {
        start: {
          line: 836,
          column: 8
        },
        end: {
          line: 836,
          column: 69
        }
      },
      "212": {
        start: {
          line: 837,
          column: 8
        },
        end: {
          line: 837,
          column: 39
        }
      },
      "213": {
        start: {
          line: 841,
          column: 2
        },
        end: {
          line: 873,
          column: 5
        }
      },
      "214": {
        start: {
          line: 842,
          column: 4
        },
        end: {
          line: 872,
          column: 7
        }
      },
      "215": {
        start: {
          line: 854,
          column: 6
        },
        end: {
          line: 856,
          column: 7
        }
      },
      "216": {
        start: {
          line: 855,
          column: 8
        },
        end: {
          line: 855,
          column: 15
        }
      },
      "217": {
        start: {
          line: 857,
          column: 6
        },
        end: {
          line: 857,
          column: 30
        }
      },
      "218": {
        start: {
          line: 858,
          column: 27
        },
        end: {
          line: 860,
          column: 7
        }
      },
      "219": {
        start: {
          line: 861,
          column: 6
        },
        end: {
          line: 871,
          column: 9
        }
      },
      "220": {
        start: {
          line: 862,
          column: 8
        },
        end: {
          line: 869,
          column: 9
        }
      },
      "221": {
        start: {
          line: 863,
          column: 10
        },
        end: {
          line: 866,
          column: 13
        }
      },
      "222": {
        start: {
          line: 867,
          column: 10
        },
        end: {
          line: 867,
          column: 35
        }
      },
      "223": {
        start: {
          line: 868,
          column: 10
        },
        end: {
          line: 868,
          column: 17
        }
      },
      "224": {
        start: {
          line: 870,
          column: 8
        },
        end: {
          line: 870,
          column: 59
        }
      },
      "225": {
        start: {
          line: 875,
          column: 2
        },
        end: {
          line: 877,
          column: 4
        }
      },
      "226": {
        start: {
          line: 876,
          column: 4
        },
        end: {
          line: 876,
          column: 40
        }
      },
      "227": {
        start: {
          line: 881,
          column: 2
        },
        end: {
          line: 886,
          column: 4
        }
      },
      "228": {
        start: {
          line: 882,
          column: 4
        },
        end: {
          line: 885,
          column: 7
        }
      },
      "229": {
        start: {
          line: 888,
          column: 2
        },
        end: {
          line: 891,
          column: 4
        }
      },
      "230": {
        start: {
          line: 889,
          column: 4
        },
        end: {
          line: 889,
          column: 28
        }
      },
      "231": {
        start: {
          line: 890,
          column: 4
        },
        end: {
          line: 890,
          column: 49
        }
      },
      "232": {
        start: {
          line: 893,
          column: 2
        },
        end: {
          line: 895,
          column: 5
        }
      },
      "233": {
        start: {
          line: 894,
          column: 4
        },
        end: {
          line: 894,
          column: 35
        }
      },
      "234": {
        start: {
          line: 917,
          column: 2
        },
        end: {
          line: 950,
          column: 4
        }
      },
      "235": {
        start: {
          line: 918,
          column: 4
        },
        end: {
          line: 918,
          column: 27
        }
      },
      "236": {
        start: {
          line: 921,
          column: 4
        },
        end: {
          line: 925,
          column: 5
        }
      },
      "237": {
        start: {
          line: 922,
          column: 8
        },
        end: {
          line: 922,
          column: 92
        }
      },
      "238": {
        start: {
          line: 924,
          column: 8
        },
        end: {
          line: 924,
          column: 35
        }
      },
      "239": {
        start: {
          line: 928,
          column: 4
        },
        end: {
          line: 931,
          column: 5
        }
      },
      "240": {
        start: {
          line: 929,
          column: 8
        },
        end: {
          line: 929,
          column: 38
        }
      },
      "241": {
        start: {
          line: 930,
          column: 8
        },
        end: {
          line: 930,
          column: 15
        }
      },
      "242": {
        start: {
          line: 934,
          column: 4
        },
        end: {
          line: 940,
          column: 5
        }
      },
      "243": {
        start: {
          line: 935,
          column: 8
        },
        end: {
          line: 936,
          column: 60
        }
      },
      "244": {
        start: {
          line: 938,
          column: 8
        },
        end: {
          line: 938,
          column: 38
        }
      },
      "245": {
        start: {
          line: 939,
          column: 8
        },
        end: {
          line: 939,
          column: 15
        }
      },
      "246": {
        start: {
          line: 942,
          column: 4
        },
        end: {
          line: 949,
          column: 7
        }
      },
      "247": {
        start: {
          line: 946,
          column: 8
        },
        end: {
          line: 946,
          column: 64
        }
      },
      "248": {
        start: {
          line: 947,
          column: 8
        },
        end: {
          line: 947,
          column: 69
        }
      },
      "249": {
        start: {
          line: 948,
          column: 8
        },
        end: {
          line: 948,
          column: 39
        }
      },
      "250": {
        start: {
          line: 955,
          column: 2
        },
        end: {
          line: 987,
          column: 5
        }
      },
      "251": {
        start: {
          line: 956,
          column: 4
        },
        end: {
          line: 986,
          column: 7
        }
      },
      "252": {
        start: {
          line: 968,
          column: 6
        },
        end: {
          line: 970,
          column: 7
        }
      },
      "253": {
        start: {
          line: 969,
          column: 8
        },
        end: {
          line: 969,
          column: 15
        }
      },
      "254": {
        start: {
          line: 971,
          column: 6
        },
        end: {
          line: 971,
          column: 30
        }
      },
      "255": {
        start: {
          line: 972,
          column: 27
        },
        end: {
          line: 974,
          column: 7
        }
      },
      "256": {
        start: {
          line: 975,
          column: 6
        },
        end: {
          line: 985,
          column: 9
        }
      },
      "257": {
        start: {
          line: 976,
          column: 8
        },
        end: {
          line: 983,
          column: 9
        }
      },
      "258": {
        start: {
          line: 977,
          column: 10
        },
        end: {
          line: 980,
          column: 13
        }
      },
      "259": {
        start: {
          line: 981,
          column: 10
        },
        end: {
          line: 981,
          column: 35
        }
      },
      "260": {
        start: {
          line: 982,
          column: 10
        },
        end: {
          line: 982,
          column: 17
        }
      },
      "261": {
        start: {
          line: 984,
          column: 8
        },
        end: {
          line: 984,
          column: 59
        }
      },
      "262": {
        start: {
          line: 989,
          column: 2
        },
        end: {
          line: 991,
          column: 4
        }
      },
      "263": {
        start: {
          line: 990,
          column: 4
        },
        end: {
          line: 990,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 49
          },
          end: {
            line: 1,
            column: 50
          }
        },
        loc: {
          start: {
            line: 1,
            column: 188
          },
          end: {
            line: 669,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 38
          }
        },
        loc: {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 6,
            column: 3
          }
        },
        line: 3
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 307,
            column: 66
          },
          end: {
            line: 307,
            column: 67
          }
        },
        loc: {
          start: {
            line: 307,
            column: 80
          },
          end: {
            line: 323,
            column: 7
          }
        },
        line: 307
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 329,
            column: 18
          },
          end: {
            line: 329,
            column: 19
          }
        },
        loc: {
          start: {
            line: 329,
            column: 37
          },
          end: {
            line: 332,
            column: 9
          }
        },
        line: 329
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 334,
            column: 21
          },
          end: {
            line: 334,
            column: 22
          }
        },
        loc: {
          start: {
            line: 334,
            column: 36
          },
          end: {
            line: 336,
            column: 9
          }
        },
        line: 334
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 338,
            column: 21
          },
          end: {
            line: 338,
            column: 22
          }
        },
        loc: {
          start: {
            line: 338,
            column: 36
          },
          end: {
            line: 349,
            column: 9
          }
        },
        line: 338
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 431,
            column: 8
          },
          end: {
            line: 431,
            column: 9
          }
        },
        loc: {
          start: {
            line: 431,
            column: 15
          },
          end: {
            line: 431,
            column: 39
          }
        },
        line: 431
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 435,
            column: 85
          },
          end: {
            line: 435,
            column: 86
          }
        },
        loc: {
          start: {
            line: 435,
            column: 93
          },
          end: {
            line: 438,
            column: 7
          }
        },
        line: 435
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 440,
            column: 85
          },
          end: {
            line: 440,
            column: 86
          }
        },
        loc: {
          start: {
            line: 440,
            column: 93
          },
          end: {
            line: 442,
            column: 7
          }
        },
        line: 440
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 460,
            column: 67
          },
          end: {
            line: 460,
            column: 68
          }
        },
        loc: {
          start: {
            line: 460,
            column: 78
          },
          end: {
            line: 517,
            column: 7
          }
        },
        line: 460
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 492,
            column: 35
          },
          end: {
            line: 492,
            column: 36
          }
        },
        loc: {
          start: {
            line: 492,
            column: 48
          },
          end: {
            line: 501,
            column: 9
          }
        },
        line: 492
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 506,
            column: 55
          },
          end: {
            line: 506,
            column: 56
          }
        },
        loc: {
          start: {
            line: 506,
            column: 65
          },
          end: {
            line: 508,
            column: 9
          }
        },
        line: 506
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 523,
            column: 8
          },
          end: {
            line: 523,
            column: 9
          }
        },
        loc: {
          start: {
            line: 523,
            column: 18
          },
          end: {
            line: 525,
            column: 9
          }
        },
        line: 523
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 541,
            column: 8
          },
          end: {
            line: 541,
            column: 9
          }
        },
        loc: {
          start: {
            line: 541,
            column: 23
          },
          end: {
            line: 561,
            column: 9
          }
        },
        line: 541
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 549,
            column: 12
          },
          end: {
            line: 549,
            column: 13
          }
        },
        loc: {
          start: {
            line: 549,
            column: 22
          },
          end: {
            line: 559,
            column: 13
          }
        },
        line: 549
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 586,
            column: 31
          },
          end: {
            line: 586,
            column: 32
          }
        },
        loc: {
          start: {
            line: 586,
            column: 66
          },
          end: {
            line: 591,
            column: 3
          }
        },
        line: 586
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 593,
            column: 27
          },
          end: {
            line: 593,
            column: 28
          }
        },
        loc: {
          start: {
            line: 593,
            column: 74
          },
          end: {
            line: 606,
            column: 3
          }
        },
        line: 593
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 609,
            column: 27
          },
          end: {
            line: 609,
            column: 28
          }
        },
        loc: {
          start: {
            line: 609,
            column: 49
          },
          end: {
            line: 625,
            column: 3
          }
        },
        line: 609
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 612,
            column: 59
          },
          end: {
            line: 612,
            column: 60
          }
        },
        loc: {
          start: {
            line: 612,
            column: 75
          },
          end: {
            line: 614,
            column: 7
          }
        },
        line: 612
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 627,
            column: 27
          },
          end: {
            line: 627,
            column: 28
          }
        },
        loc: {
          start: {
            line: 627,
            column: 49
          },
          end: {
            line: 643,
            column: 3
          }
        },
        line: 627
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 630,
            column: 59
          },
          end: {
            line: 630,
            column: 60
          }
        },
        loc: {
          start: {
            line: 630,
            column: 75
          },
          end: {
            line: 632,
            column: 7
          }
        },
        line: 630
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 646,
            column: 29
          },
          end: {
            line: 646,
            column: 30
          }
        },
        loc: {
          start: {
            line: 646,
            column: 41
          },
          end: {
            line: 655,
            column: 3
          }
        },
        line: 646
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 657,
            column: 29
          },
          end: {
            line: 657,
            column: 30
          }
        },
        loc: {
          start: {
            line: 657,
            column: 41
          },
          end: {
            line: 666,
            column: 3
          }
        },
        line: 657
      },
      "23": {
        name: "portfolioCtrl_edit",
        decl: {
          start: {
            line: 671,
            column: 9
          },
          end: {
            line: 671,
            column: 27
          }
        },
        loc: {
          start: {
            line: 671,
            column: 109
          },
          end: {
            line: 787,
            column: 1
          }
        },
        line: 671
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 675,
            column: 48
          },
          end: {
            line: 675,
            column: 49
          }
        },
        loc: {
          start: {
            line: 675,
            column: 58
          },
          end: {
            line: 687,
            column: 3
          }
        },
        line: 675
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 696,
            column: 4
          },
          end: {
            line: 696,
            column: 5
          }
        },
        loc: {
          start: {
            line: 696,
            column: 14
          },
          end: {
            line: 712,
            column: 5
          }
        },
        line: 696
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 715,
            column: 24
          },
          end: {
            line: 715,
            column: 25
          }
        },
        loc: {
          start: {
            line: 715,
            column: 36
          },
          end: {
            line: 783,
            column: 3
          }
        },
        line: 715
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 720,
            column: 48
          },
          end: {
            line: 720,
            column: 49
          }
        },
        loc: {
          start: {
            line: 720,
            column: 56
          },
          end: {
            line: 722,
            column: 5
          }
        },
        line: 720
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 778,
            column: 6
          },
          end: {
            line: 778,
            column: 7
          }
        },
        loc: {
          start: {
            line: 778,
            column: 17
          },
          end: {
            line: 781,
            column: 7
          }
        },
        line: 778
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 784,
            column: 22
          },
          end: {
            line: 784,
            column: 23
          }
        },
        loc: {
          start: {
            line: 784,
            column: 34
          },
          end: {
            line: 786,
            column: 3
          }
        },
        line: 784
      },
      "30": {
        name: "Personnalize_1_Ctrl_Project_edit",
        decl: {
          start: {
            line: 789,
            column: 9
          },
          end: {
            line: 789,
            column: 41
          }
        },
        loc: {
          start: {
            line: 789,
            column: 116
          },
          end: {
            line: 878,
            column: 1
          }
        },
        line: 789
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 790,
            column: 23
          },
          end: {
            line: 790,
            column: 24
          }
        },
        loc: {
          start: {
            line: 790,
            column: 35
          },
          end: {
            line: 795,
            column: 3
          }
        },
        line: 790
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 797,
            column: 24
          },
          end: {
            line: 797,
            column: 25
          }
        },
        loc: {
          start: {
            line: 797,
            column: 40
          },
          end: {
            line: 800,
            column: 3
          }
        },
        line: 797
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 802,
            column: 27
          },
          end: {
            line: 802,
            column: 28
          }
        },
        loc: {
          start: {
            line: 802,
            column: 33
          },
          end: {
            line: 804,
            column: 3
          }
        },
        line: 802
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 806,
            column: 28
          },
          end: {
            line: 806,
            column: 29
          }
        },
        loc: {
          start: {
            line: 806,
            column: 39
          },
          end: {
            line: 839,
            column: 3
          }
        },
        line: 806
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 823,
            column: 37
          },
          end: {
            line: 823,
            column: 38
          }
        },
        loc: {
          start: {
            line: 823,
            column: 49
          },
          end: {
            line: 826,
            column: 5
          }
        },
        line: 823
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 834,
            column: 7
          },
          end: {
            line: 834,
            column: 8
          }
        },
        loc: {
          start: {
            line: 834,
            column: 15
          },
          end: {
            line: 838,
            column: 5
          }
        },
        line: 834
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 841,
            column: 27
          },
          end: {
            line: 841,
            column: 28
          }
        },
        loc: {
          start: {
            line: 841,
            column: 35
          },
          end: {
            line: 873,
            column: 3
          }
        },
        line: 841
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 853,
            column: 7
          },
          end: {
            line: 853,
            column: 8
          }
        },
        loc: {
          start: {
            line: 853,
            column: 20
          },
          end: {
            line: 872,
            column: 5
          }
        },
        line: 853
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 861,
            column: 81
          },
          end: {
            line: 861,
            column: 82
          }
        },
        loc: {
          start: {
            line: 861,
            column: 89
          },
          end: {
            line: 871,
            column: 7
          }
        },
        line: 861
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 875,
            column: 22
          },
          end: {
            line: 875,
            column: 23
          }
        },
        loc: {
          start: {
            line: 875,
            column: 34
          },
          end: {
            line: 877,
            column: 3
          }
        },
        line: 875
      },
      "41": {
        name: "Personnalize_2_Ctrl_Project_edit",
        decl: {
          start: {
            line: 880,
            column: 9
          },
          end: {
            line: 880,
            column: 41
          }
        },
        loc: {
          start: {
            line: 880,
            column: 116
          },
          end: {
            line: 992,
            column: 1
          }
        },
        line: 880
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 881,
            column: 23
          },
          end: {
            line: 881,
            column: 24
          }
        },
        loc: {
          start: {
            line: 881,
            column: 35
          },
          end: {
            line: 886,
            column: 3
          }
        },
        line: 881
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 888,
            column: 24
          },
          end: {
            line: 888,
            column: 25
          }
        },
        loc: {
          start: {
            line: 888,
            column: 40
          },
          end: {
            line: 891,
            column: 3
          }
        },
        line: 888
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 893,
            column: 27
          },
          end: {
            line: 893,
            column: 28
          }
        },
        loc: {
          start: {
            line: 893,
            column: 33
          },
          end: {
            line: 895,
            column: 3
          }
        },
        line: 893
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 917,
            column: 28
          },
          end: {
            line: 917,
            column: 29
          }
        },
        loc: {
          start: {
            line: 917,
            column: 39
          },
          end: {
            line: 950,
            column: 3
          }
        },
        line: 917
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 934,
            column: 37
          },
          end: {
            line: 934,
            column: 38
          }
        },
        loc: {
          start: {
            line: 934,
            column: 49
          },
          end: {
            line: 937,
            column: 5
          }
        },
        line: 934
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 945,
            column: 7
          },
          end: {
            line: 945,
            column: 8
          }
        },
        loc: {
          start: {
            line: 945,
            column: 15
          },
          end: {
            line: 949,
            column: 5
          }
        },
        line: 945
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 955,
            column: 27
          },
          end: {
            line: 955,
            column: 28
          }
        },
        loc: {
          start: {
            line: 955,
            column: 35
          },
          end: {
            line: 987,
            column: 3
          }
        },
        line: 955
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 967,
            column: 7
          },
          end: {
            line: 967,
            column: 8
          }
        },
        loc: {
          start: {
            line: 967,
            column: 20
          },
          end: {
            line: 986,
            column: 5
          }
        },
        line: 967
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 975,
            column: 81
          },
          end: {
            line: 975,
            column: 82
          }
        },
        loc: {
          start: {
            line: 975,
            column: 89
          },
          end: {
            line: 985,
            column: 7
          }
        },
        line: 975
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 989,
            column: 22
          },
          end: {
            line: 989,
            column: 23
          }
        },
        loc: {
          start: {
            line: 989,
            column: 34
          },
          end: {
            line: 991,
            column: 3
          }
        },
        line: 989
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }, {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 32,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 30,
            column: 39
          }
        }, {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 31
          }
        }, {
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 32
          }
        }],
        line: 30
      },
      "3": {
        loc: {
          start: {
            line: 287,
            column: 22
          },
          end: {
            line: 287,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 287,
            column: 29
          },
          end: {
            line: 287,
            column: 38
          }
        }],
        line: 287
      },
      "4": {
        loc: {
          start: {
            line: 287,
            column: 40
          },
          end: {
            line: 287,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 287,
            column: 47
          },
          end: {
            line: 287,
            column: 52
          }
        }],
        line: 287
      },
      "5": {
        loc: {
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 290,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 290,
            column: 7
          }
        }, {
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 290,
            column: 7
          }
        }],
        line: 288
      },
      "6": {
        loc: {
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        }, {
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        }],
        line: 297
      },
      "7": {
        loc: {
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 322,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 322,
            column: 9
          }
        }, {
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 322,
            column: 9
          }
        }],
        line: 309
      },
      "8": {
        loc: {
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 316,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 316,
            column: 11
          }
        }, {
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 316,
            column: 11
          }
        }],
        line: 310
      },
      "9": {
        loc: {
          start: {
            line: 317,
            column: 10
          },
          end: {
            line: 321,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 10
          },
          end: {
            line: 321,
            column: 11
          }
        }, {
          start: {
            line: 317,
            column: 10
          },
          end: {
            line: 321,
            column: 11
          }
        }],
        line: 317
      },
      "10": {
        loc: {
          start: {
            line: 317,
            column: 14
          },
          end: {
            line: 317,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 14
          },
          end: {
            line: 317,
            column: 29
          }
        }, {
          start: {
            line: 317,
            column: 33
          },
          end: {
            line: 317,
            column: 48
          }
        }],
        line: 317
      },
      "11": {
        loc: {
          start: {
            line: 325,
            column: 14
          },
          end: {
            line: 325,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 325,
            column: 21
          },
          end: {
            line: 325,
            column: 23
          }
        }],
        line: 325
      },
      "12": {
        loc: {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        }, {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        }],
        line: 328
      },
      "13": {
        loc: {
          start: {
            line: 331,
            column: 17
          },
          end: {
            line: 331,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 331,
            column: 78
          },
          end: {
            line: 331,
            column: 79
          }
        }, {
          start: {
            line: 331,
            column: 82
          },
          end: {
            line: 331,
            column: 84
          }
        }],
        line: 331
      },
      "14": {
        loc: {
          start: {
            line: 341,
            column: 10
          },
          end: {
            line: 346,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 341,
            column: 10
          },
          end: {
            line: 346,
            column: 11
          }
        }, {
          start: {
            line: 341,
            column: 10
          },
          end: {
            line: 346,
            column: 11
          }
        }],
        line: 341
      },
      "15": {
        loc: {
          start: {
            line: 358,
            column: 12
          },
          end: {
            line: 358,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 358,
            column: 21
          },
          end: {
            line: 358,
            column: 25
          }
        }],
        line: 358
      },
      "16": {
        loc: {
          start: {
            line: 362,
            column: 19
          },
          end: {
            line: 362,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 362,
            column: 20
          },
          end: {
            line: 362,
            column: 50
          }
        }, {
          start: {
            line: 362,
            column: 55
          },
          end: {
            line: 362,
            column: 56
          }
        }],
        line: 362
      },
      "17": {
        loc: {
          start: {
            line: 362,
            column: 20
          },
          end: {
            line: 362,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 362,
            column: 37
          },
          end: {
            line: 362,
            column: 38
          }
        }, {
          start: {
            line: 362,
            column: 41
          },
          end: {
            line: 362,
            column: 50
          }
        }],
        line: 362
      },
      "18": {
        loc: {
          start: {
            line: 430,
            column: 38
          },
          end: {
            line: 432,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 430,
            column: 38
          },
          end: {
            line: 432,
            column: 7
          }
        }, {
          start: {
            line: 432,
            column: 11
          },
          end: {
            line: 432,
            column: 20
          }
        }],
        line: 430
      },
      "19": {
        loc: {
          start: {
            line: 458,
            column: 9
          },
          end: {
            line: 458,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 458,
            column: 9
          },
          end: {
            line: 458,
            column: 48
          }
        }, {
          start: {
            line: 458,
            column: 52
          },
          end: {
            line: 458,
            column: 56
          }
        }],
        line: 458
      },
      "20": {
        loc: {
          start: {
            line: 510,
            column: 26
          },
          end: {
            line: 510,
            column: 162
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 510,
            column: 27
          },
          end: {
            line: 510,
            column: 54
          }
        }, {
          start: {
            line: 510,
            column: 58
          },
          end: {
            line: 510,
            column: 94
          }
        }, {
          start: {
            line: 510,
            column: 100
          },
          end: {
            line: 510,
            column: 126
          }
        }, {
          start: {
            line: 510,
            column: 130
          },
          end: {
            line: 510,
            column: 161
          }
        }],
        line: 510
      },
      "21": {
        loc: {
          start: {
            line: 511,
            column: 8
          },
          end: {
            line: 515,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 511,
            column: 8
          },
          end: {
            line: 515,
            column: 9
          }
        }, {
          start: {
            line: 511,
            column: 8
          },
          end: {
            line: 515,
            column: 9
          }
        }],
        line: 511
      },
      "22": {
        loc: {
          start: {
            line: 511,
            column: 12
          },
          end: {
            line: 511,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 511,
            column: 12
          },
          end: {
            line: 511,
            column: 21
          }
        }, {
          start: {
            line: 511,
            column: 25
          },
          end: {
            line: 511,
            column: 65
          }
        }],
        line: 511
      },
      "23": {
        loc: {
          start: {
            line: 513,
            column: 27
          },
          end: {
            line: 513,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 513,
            column: 27
          },
          end: {
            line: 513,
            column: 45
          }
        }, {
          start: {
            line: 513,
            column: 49
          },
          end: {
            line: 513,
            column: 58
          }
        }],
        line: 513
      },
      "24": {
        loc: {
          start: {
            line: 522,
            column: 30
          },
          end: {
            line: 522,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 522,
            column: 30
          },
          end: {
            line: 522,
            column: 60
          }
        }, {
          start: {
            line: 522,
            column: 64
          },
          end: {
            line: 522,
            column: 65
          }
        }],
        line: 522
      },
      "25": {
        loc: {
          start: {
            line: 522,
            column: 31
          },
          end: {
            line: 522,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 522,
            column: 31
          },
          end: {
            line: 522,
            column: 43
          }
        }, {
          start: {
            line: 522,
            column: 47
          },
          end: {
            line: 522,
            column: 56
          }
        }],
        line: 522
      },
      "26": {
        loc: {
          start: {
            line: 542,
            column: 10
          },
          end: {
            line: 544,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 542,
            column: 10
          },
          end: {
            line: 544,
            column: 11
          }
        }, {
          start: {
            line: 542,
            column: 10
          },
          end: {
            line: 544,
            column: 11
          }
        }],
        line: 542
      },
      "27": {
        loc: {
          start: {
            line: 550,
            column: 14
          },
          end: {
            line: 557,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 550,
            column: 14
          },
          end: {
            line: 557,
            column: 15
          }
        }, {
          start: {
            line: 550,
            column: 14
          },
          end: {
            line: 557,
            column: 15
          }
        }],
        line: 550
      },
      "28": {
        loc: {
          start: {
            line: 596,
            column: 6
          },
          end: {
            line: 602,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 596,
            column: 6
          },
          end: {
            line: 602,
            column: 7
          }
        }, {
          start: {
            line: 596,
            column: 6
          },
          end: {
            line: 602,
            column: 7
          }
        }],
        line: 596
      },
      "29": {
        loc: {
          start: {
            line: 610,
            column: 28
          },
          end: {
            line: 610,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 610,
            column: 28
          },
          end: {
            line: 610,
            column: 49
          }
        }, {
          start: {
            line: 610,
            column: 53
          },
          end: {
            line: 610,
            column: 55
          }
        }],
        line: 610
      },
      "30": {
        loc: {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        }, {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        }],
        line: 611
      },
      "31": {
        loc: {
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        }, {
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        }],
        line: 618
      },
      "32": {
        loc: {
          start: {
            line: 628,
            column: 28
          },
          end: {
            line: 628,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 628,
            column: 28
          },
          end: {
            line: 628,
            column: 49
          }
        }, {
          start: {
            line: 628,
            column: 53
          },
          end: {
            line: 628,
            column: 55
          }
        }],
        line: 628
      },
      "33": {
        loc: {
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 634,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 634,
            column: 5
          }
        }, {
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 634,
            column: 5
          }
        }],
        line: 629
      },
      "34": {
        loc: {
          start: {
            line: 636,
            column: 6
          },
          end: {
            line: 640,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 636,
            column: 6
          },
          end: {
            line: 640,
            column: 7
          }
        }, {
          start: {
            line: 636,
            column: 6
          },
          end: {
            line: 640,
            column: 7
          }
        }],
        line: 636
      },
      "35": {
        loc: {
          start: {
            line: 693,
            column: 10
          },
          end: {
            line: 693,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 693,
            column: 10
          },
          end: {
            line: 693,
            column: 37
          }
        }, {
          start: {
            line: 693,
            column: 41
          },
          end: {
            line: 693,
            column: 42
          }
        }],
        line: 693
      },
      "36": {
        loc: {
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        }, {
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        }],
        line: 697
      },
      "37": {
        loc: {
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        }, {
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        }],
        line: 704
      },
      "38": {
        loc: {
          start: {
            line: 721,
            column: 13
          },
          end: {
            line: 721,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 721,
            column: 13
          },
          end: {
            line: 721,
            column: 56
          }
        }, {
          start: {
            line: 721,
            column: 60
          },
          end: {
            line: 721,
            column: 76
          }
        }],
        line: 721
      },
      "39": {
        loc: {
          start: {
            line: 724,
            column: 4
          },
          end: {
            line: 727,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 724,
            column: 4
          },
          end: {
            line: 727,
            column: 5
          }
        }, {
          start: {
            line: 724,
            column: 4
          },
          end: {
            line: 727,
            column: 5
          }
        }],
        line: 724
      },
      "40": {
        loc: {
          start: {
            line: 810,
            column: 4
          },
          end: {
            line: 814,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 810,
            column: 4
          },
          end: {
            line: 814,
            column: 5
          }
        }, {
          start: {
            line: 810,
            column: 4
          },
          end: {
            line: 814,
            column: 5
          }
        }],
        line: 810
      },
      "41": {
        loc: {
          start: {
            line: 810,
            column: 8
          },
          end: {
            line: 810,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 810,
            column: 8
          },
          end: {
            line: 810,
            column: 30
          }
        }, {
          start: {
            line: 810,
            column: 34
          },
          end: {
            line: 810,
            column: 71
          }
        }],
        line: 810
      },
      "42": {
        loc: {
          start: {
            line: 817,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 817,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        }, {
          start: {
            line: 817,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        }],
        line: 817
      },
      "43": {
        loc: {
          start: {
            line: 817,
            column: 8
          },
          end: {
            line: 817,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 817,
            column: 8
          },
          end: {
            line: 817,
            column: 32
          }
        }, {
          start: {
            line: 817,
            column: 36
          },
          end: {
            line: 817,
            column: 65
          }
        }],
        line: 817
      },
      "44": {
        loc: {
          start: {
            line: 823,
            column: 4
          },
          end: {
            line: 829,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 823,
            column: 4
          },
          end: {
            line: 829,
            column: 5
          }
        }, {
          start: {
            line: 823,
            column: 4
          },
          end: {
            line: 829,
            column: 5
          }
        }],
        line: 823
      },
      "45": {
        loc: {
          start: {
            line: 824,
            column: 15
          },
          end: {
            line: 825,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 824,
            column: 15
          },
          end: {
            line: 824,
            column: 89
          }
        }, {
          start: {
            line: 825,
            column: 18
          },
          end: {
            line: 825,
            column: 59
          }
        }],
        line: 824
      },
      "46": {
        loc: {
          start: {
            line: 854,
            column: 6
          },
          end: {
            line: 856,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 854,
            column: 6
          },
          end: {
            line: 856,
            column: 7
          }
        }, {
          start: {
            line: 854,
            column: 6
          },
          end: {
            line: 856,
            column: 7
          }
        }],
        line: 854
      },
      "47": {
        loc: {
          start: {
            line: 862,
            column: 8
          },
          end: {
            line: 869,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 862,
            column: 8
          },
          end: {
            line: 869,
            column: 9
          }
        }, {
          start: {
            line: 862,
            column: 8
          },
          end: {
            line: 869,
            column: 9
          }
        }],
        line: 862
      },
      "48": {
        loc: {
          start: {
            line: 921,
            column: 4
          },
          end: {
            line: 925,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 921,
            column: 4
          },
          end: {
            line: 925,
            column: 5
          }
        }, {
          start: {
            line: 921,
            column: 4
          },
          end: {
            line: 925,
            column: 5
          }
        }],
        line: 921
      },
      "49": {
        loc: {
          start: {
            line: 921,
            column: 8
          },
          end: {
            line: 921,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 921,
            column: 8
          },
          end: {
            line: 921,
            column: 30
          }
        }, {
          start: {
            line: 921,
            column: 34
          },
          end: {
            line: 921,
            column: 71
          }
        }],
        line: 921
      },
      "50": {
        loc: {
          start: {
            line: 928,
            column: 4
          },
          end: {
            line: 931,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 928,
            column: 4
          },
          end: {
            line: 931,
            column: 5
          }
        }, {
          start: {
            line: 928,
            column: 4
          },
          end: {
            line: 931,
            column: 5
          }
        }],
        line: 928
      },
      "51": {
        loc: {
          start: {
            line: 928,
            column: 8
          },
          end: {
            line: 928,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 928,
            column: 8
          },
          end: {
            line: 928,
            column: 32
          }
        }, {
          start: {
            line: 928,
            column: 36
          },
          end: {
            line: 928,
            column: 65
          }
        }],
        line: 928
      },
      "52": {
        loc: {
          start: {
            line: 934,
            column: 4
          },
          end: {
            line: 940,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 934,
            column: 4
          },
          end: {
            line: 940,
            column: 5
          }
        }, {
          start: {
            line: 934,
            column: 4
          },
          end: {
            line: 940,
            column: 5
          }
        }],
        line: 934
      },
      "53": {
        loc: {
          start: {
            line: 935,
            column: 15
          },
          end: {
            line: 936,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 935,
            column: 15
          },
          end: {
            line: 935,
            column: 89
          }
        }, {
          start: {
            line: 936,
            column: 18
          },
          end: {
            line: 936,
            column: 59
          }
        }],
        line: 935
      },
      "54": {
        loc: {
          start: {
            line: 968,
            column: 6
          },
          end: {
            line: 970,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 968,
            column: 6
          },
          end: {
            line: 970,
            column: 7
          }
        }, {
          start: {
            line: 968,
            column: 6
          },
          end: {
            line: 970,
            column: 7
          }
        }],
        line: 968
      },
      "55": {
        loc: {
          start: {
            line: 976,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 976,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        }, {
          start: {
            line: 976,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        }],
        line: 976
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2bpe87ftbo.s[0]++;
angular.module("app").controller("PortfolioCtrl", function ($scope, $rootScope, $state, $uibModal, $translate, $stateParams, $CRUDService, FileUploader, SweetAlert, $deltahttp, $log, $document) {
  cov_2bpe87ftbo.f[0]++;

  var PATH = (cov_2bpe87ftbo.s[1]++, "Projet");
  cov_2bpe87ftbo.s[2]++;
  $rootScope.processPageRight("1_1", function () {
    cov_2bpe87ftbo.f[1]++;
    cov_2bpe87ftbo.s[3]++;

    $rootScope.global_access_page_denied = false;
    cov_2bpe87ftbo.s[4]++;
    $rootScope.currentRight.v = true;
  });
  cov_2bpe87ftbo.s[5]++;
  $rootScope.clearProject();
  cov_2bpe87ftbo.s[6]++;
  if (!$rootScope.connectedUser.finalSuperAdmin) {
    cov_2bpe87ftbo.b[0][0]++;
    cov_2bpe87ftbo.s[7]++;

    $rootScope.connectedUser.isAdmin = false;
    cov_2bpe87ftbo.s[8]++;
    $rootScope.connectedUser.superAdmin = false;
  } else {
    cov_2bpe87ftbo.b[0][1]++;
  }
  cov_2bpe87ftbo.s[9]++;
  $rootScope.homePortfolio = true;

  cov_2bpe87ftbo.s[10]++;
  $scope.view = {
    filter: "",
    defaultTitle: "",
    tmpDefaultTitle: "",
    displayType: true,
    currentDate: new Date(),
    historic: [],
    portfolios: [],
    opened: {},
    addSubPortfolio: function addSubPortfolio(id) {
      cov_2bpe87ftbo.s[11]++;

      this.opened[id] = !this.opened[id];
    },
    filterProcess: function filterProcess(item, index, items) {
      cov_2bpe87ftbo.s[12]++;

      for (var _iterator = Object.keys($scope.view.opened), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var id = _ref;
        cov_2bpe87ftbo.s[13]++;

        if ((cov_2bpe87ftbo.b[2][0]++, item.custom_id.startsWith(id)) && (cov_2bpe87ftbo.b[2][1]++, item.custom_id !== id) && (cov_2bpe87ftbo.b[2][2]++, $scope.view.opened[id])) {
          cov_2bpe87ftbo.b[1][0]++;
          cov_2bpe87ftbo.s[14]++;

          return false;
        } else {
          cov_2bpe87ftbo.b[1][1]++;
        }
      }
      cov_2bpe87ftbo.s[15]++;
      return true;
    },

    contries: [{ id: 1, name: $translate.instant("COUNTRIES.AF") }, { id: 2, name: $translate.instant("COUNTRIES.AX") }, { id: 3, name: $translate.instant("COUNTRIES.AL") }, { id: 4, name: $translate.instant("COUNTRIES.DZ") }, { id: 5, name: $translate.instant("COUNTRIES.AS") }, { id: 6, name: $translate.instant("COUNTRIES.AD") }, { id: 7, name: $translate.instant("COUNTRIES.AO") }, { id: 8, name: $translate.instant("COUNTRIES.AI") }, { id: 9, name: $translate.instant("COUNTRIES.AQ") }, { id: 10, name: $translate.instant("COUNTRIES.AG") }, { id: 11, name: $translate.instant("COUNTRIES.AR") }, { id: 12, name: $translate.instant("COUNTRIES.AM") }, { id: 13, name: $translate.instant("COUNTRIES.AW") }, { id: 14, name: $translate.instant("COUNTRIES.AU") }, { id: 15, name: $translate.instant("COUNTRIES.AT") }, { id: 16, name: $translate.instant("COUNTRIES.AZ") }, { id: 17, name: $translate.instant("COUNTRIES.BS") }, { id: 18, name: $translate.instant("COUNTRIES.BH") }, { id: 19, name: $translate.instant("COUNTRIES.BD") }, { id: 20, name: $translate.instant("COUNTRIES.BB") }, { id: 21, name: $translate.instant("COUNTRIES.BY") }, { id: 22, name: $translate.instant("COUNTRIES.BE") }, { id: 23, name: $translate.instant("COUNTRIES.BZ") }, { id: 24, name: $translate.instant("COUNTRIES.BJ") }, { id: 25, name: $translate.instant("COUNTRIES.BM") }, { id: 26, name: $translate.instant("COUNTRIES.BT") }, { id: 27, name: $translate.instant("COUNTRIES.BO") }, { id: 28, name: $translate.instant("COUNTRIES.BA") }, { id: 29, name: $translate.instant("COUNTRIES.BW") }, { id: 30, name: $translate.instant("COUNTRIES.BV") }, { id: 31, name: $translate.instant("COUNTRIES.BR") }, { id: 32, name: $translate.instant("COUNTRIES.IO") }, { id: 33, name: $translate.instant("COUNTRIES.BN") }, { id: 34, name: $translate.instant("COUNTRIES.BG") }, { id: 35, name: $translate.instant("COUNTRIES.BF") }, { id: 36, name: $translate.instant("COUNTRIES.BI") }, { id: 37, name: $translate.instant("COUNTRIES.KH") }, { id: 38, name: $translate.instant("COUNTRIES.CM") }, { id: 39, name: $translate.instant("COUNTRIES.CA") }, { id: 40, name: $translate.instant("COUNTRIES.CV") }, { id: 41, name: $translate.instant("COUNTRIES.KY") }, { id: 42, name: $translate.instant("COUNTRIES.CF") }, { id: 43, name: $translate.instant("COUNTRIES.TD") }, { id: 44, name: $translate.instant("COUNTRIES.CL") }, { id: 45, name: $translate.instant("COUNTRIES.CN") }, { id: 46, name: $translate.instant("COUNTRIES.CX") }, { id: 47, name: $translate.instant("COUNTRIES.CC") }, { id: 48, name: $translate.instant("COUNTRIES.CO") }, { id: 49, name: $translate.instant("COUNTRIES.KM") }, { id: 50, name: $translate.instant("COUNTRIES.CG") }, { id: 51, name: $translate.instant("COUNTRIES.CD") }, { id: 52, name: $translate.instant("COUNTRIES.CK") }, { id: 53, name: $translate.instant("COUNTRIES.CR") }, { id: 54, name: $translate.instant("COUNTRIES.CI") }, { id: 55, name: $translate.instant("COUNTRIES.HR") }, { id: 56, name: $translate.instant("COUNTRIES.CU") }, { id: 57, name: $translate.instant("COUNTRIES.CY") }, { id: 58, name: $translate.instant("COUNTRIES.CZ") }, { id: 59, name: $translate.instant("COUNTRIES.DK") }, { id: 60, name: $translate.instant("COUNTRIES.DJ") }, { id: 61, name: $translate.instant("COUNTRIES.DM") }, { id: 62, name: $translate.instant("COUNTRIES.DO") }, { id: 63, name: $translate.instant("COUNTRIES.EC") }, { id: 64, name: $translate.instant("COUNTRIES.EG") }, { id: 65, name: $translate.instant("COUNTRIES.SV") }, { id: 66, name: $translate.instant("COUNTRIES.GQ") }, { id: 67, name: $translate.instant("COUNTRIES.ER") }, { id: 68, name: $translate.instant("COUNTRIES.EE") }, { id: 69, name: $translate.instant("COUNTRIES.ET") }, { id: 70, name: $translate.instant("COUNTRIES.FK") }, { id: 71, name: $translate.instant("COUNTRIES.FO") }, { id: 72, name: $translate.instant("COUNTRIES.FJ") }, { id: 73, name: $translate.instant("COUNTRIES.FI") }, { id: 74, name: $translate.instant("COUNTRIES.FR") }, { id: 75, name: $translate.instant("COUNTRIES.GF") }, { id: 76, name: $translate.instant("COUNTRIES.PF") }, { id: 77, name: $translate.instant("COUNTRIES.TF") }, { id: 78, name: $translate.instant("COUNTRIES.GA") }, { id: 79, name: $translate.instant("COUNTRIES.GM") }, { id: 80, name: $translate.instant("COUNTRIES.GE") }, { id: 81, name: $translate.instant("COUNTRIES.DE") }, { id: 82, name: $translate.instant("COUNTRIES.GH") }, { id: 83, name: $translate.instant("COUNTRIES.GI") }, { id: 84, name: $translate.instant("COUNTRIES.GR") }, { id: 85, name: $translate.instant("COUNTRIES.GL") }, { id: 86, name: $translate.instant("COUNTRIES.GD") }, { id: 87, name: $translate.instant("COUNTRIES.GP") }, { id: 88, name: $translate.instant("COUNTRIES.GU") }, { id: 89, name: $translate.instant("COUNTRIES.GT") }, { id: 90, name: $translate.instant("COUNTRIES.GG") }, { id: 91, name: $translate.instant("COUNTRIES.GN") }, { id: 92, name: $translate.instant("COUNTRIES.GW") }, { id: 93, name: $translate.instant("COUNTRIES.GY") }, { id: 94, name: $translate.instant("COUNTRIES.HT") }, { id: 95, name: $translate.instant("COUNTRIES.HM") }, { id: 96, name: $translate.instant("COUNTRIES.VA") }, { id: 97, name: $translate.instant("COUNTRIES.HN") }, { id: 98, name: $translate.instant("COUNTRIES.HK") }, { id: 99, name: $translate.instant("COUNTRIES.HU") }, { id: 100, name: $translate.instant("COUNTRIES.IS") }, { id: 101, name: $translate.instant("COUNTRIES.IN") }, { id: 102, name: $translate.instant("COUNTRIES.ID") }, { id: 103, name: $translate.instant("COUNTRIES.IR") }, { id: 104, name: $translate.instant("COUNTRIES.IQ") }, { id: 105, name: $translate.instant("COUNTRIES.IE") }, { id: 106, name: $translate.instant("COUNTRIES.IM") }, { id: 107, name: $translate.instant("COUNTRIES.IL") }, { id: 108, name: $translate.instant("COUNTRIES.IT") }, { id: 109, name: $translate.instant("COUNTRIES.JM") }, { id: 110, name: $translate.instant("COUNTRIES.JP") }, { id: 111, name: $translate.instant("COUNTRIES.JE") }, { id: 112, name: $translate.instant("COUNTRIES.JO") }, { id: 113, name: $translate.instant("COUNTRIES.KZ") }, { id: 114, name: $translate.instant("COUNTRIES.KE") }, { id: 115, name: $translate.instant("COUNTRIES.KI") }, { id: 116, name: $translate.instant("COUNTRIES.KP") }, { id: 117, name: $translate.instant("COUNTRIES.KR") }, { id: 118, name: $translate.instant("COUNTRIES.KW") }, { id: 119, name: $translate.instant("COUNTRIES.KG") }, { id: 120, name: $translate.instant("COUNTRIES.LA") }, { id: 121, name: $translate.instant("COUNTRIES.LV") }, { id: 122, name: $translate.instant("COUNTRIES.LB") }, { id: 123, name: $translate.instant("COUNTRIES.LS") }, { id: 124, name: $translate.instant("COUNTRIES.LR") }, { id: 125, name: $translate.instant("COUNTRIES.LY") }, { id: 126, name: $translate.instant("COUNTRIES.LI") }, { id: 127, name: $translate.instant("COUNTRIES.LT") }, { id: 128, name: $translate.instant("COUNTRIES.LU") }, { id: 129, name: $translate.instant("COUNTRIES.MO") }, { id: 130, name: $translate.instant("COUNTRIES.MK") }, { id: 131, name: $translate.instant("COUNTRIES.MG") }, { id: 132, name: $translate.instant("COUNTRIES.MW") }, { id: 133, name: $translate.instant("COUNTRIES.MY") }, { id: 134, name: $translate.instant("COUNTRIES.MV") }, { id: 135, name: $translate.instant("COUNTRIES.ML") }, { id: 136, name: $translate.instant("COUNTRIES.MT") }, { id: 137, name: $translate.instant("COUNTRIES.MH") }, { id: 138, name: $translate.instant("COUNTRIES.MQ") }, { id: 139, name: $translate.instant("COUNTRIES.MR") }, { id: 140, name: $translate.instant("COUNTRIES.MU") }, { id: 141, name: $translate.instant("COUNTRIES.YT") }, { id: 142, name: $translate.instant("COUNTRIES.MX") }, { id: 143, name: $translate.instant("COUNTRIES.FM") }, { id: 144, name: $translate.instant("COUNTRIES.MD") }, { id: 145, name: $translate.instant("COUNTRIES.MC") }, { id: 146, name: $translate.instant("COUNTRIES.MN") }, { id: 147, name: $translate.instant("COUNTRIES.MS") }, { id: 148, name: $translate.instant("COUNTRIES.MA") }, { id: 149, name: $translate.instant("COUNTRIES.MZ") }, { id: 150, name: $translate.instant("COUNTRIES.MM") }, { id: 151, name: $translate.instant("COUNTRIES.NA") }, { id: 152, name: $translate.instant("COUNTRIES.NR") }, { id: 153, name: $translate.instant("COUNTRIES.NP") }, { id: 154, name: $translate.instant("COUNTRIES.NL") }, { id: 155, name: $translate.instant("COUNTRIES.AN") }, { id: 156, name: $translate.instant("COUNTRIES.NC") }, { id: 157, name: $translate.instant("COUNTRIES.NZ") }, { id: 158, name: $translate.instant("COUNTRIES.NI") }, { id: 159, name: $translate.instant("COUNTRIES.NE") }, { id: 160, name: $translate.instant("COUNTRIES.NG") }, { id: 161, name: $translate.instant("COUNTRIES.NU") }, { id: 162, name: $translate.instant("COUNTRIES.NF") }, { id: 163, name: $translate.instant("COUNTRIES.MP") }, { id: 164, name: $translate.instant("COUNTRIES.NO") }, { id: 165, name: $translate.instant("COUNTRIES.OM") }, { id: 166, name: $translate.instant("COUNTRIES.PK") }, { id: 167, name: $translate.instant("COUNTRIES.PW") }, { id: 168, name: $translate.instant("COUNTRIES.PS") }, { id: 169, name: $translate.instant("COUNTRIES.PA") }, { id: 170, name: $translate.instant("COUNTRIES.PG") }, { id: 171, name: $translate.instant("COUNTRIES.PY") }, { id: 172, name: $translate.instant("COUNTRIES.PE") }, { id: 173, name: $translate.instant("COUNTRIES.PH") }, { id: 174, name: $translate.instant("COUNTRIES.PN") }, { id: 175, name: $translate.instant("COUNTRIES.PL") }, { id: 176, name: $translate.instant("COUNTRIES.PT") }, { id: 177, name: $translate.instant("COUNTRIES.PR") }, { id: 178, name: $translate.instant("COUNTRIES.QA") }, { id: 179, name: $translate.instant("COUNTRIES.RE") }, { id: 180, name: $translate.instant("COUNTRIES.RO") }, { id: 181, name: $translate.instant("COUNTRIES.RU") }, { id: 182, name: $translate.instant("COUNTRIES.RW") }, { id: 183, name: $translate.instant("COUNTRIES.SH") }, { id: 184, name: $translate.instant("COUNTRIES.KN") }, { id: 185, name: $translate.instant("COUNTRIES.LC") }, { id: 186, name: $translate.instant("COUNTRIES.PM") }, { id: 187, name: $translate.instant("COUNTRIES.VC") }, { id: 188, name: $translate.instant("COUNTRIES.WS") }, { id: 189, name: $translate.instant("COUNTRIES.SM") }, { id: 190, name: $translate.instant("COUNTRIES.ST") }, { id: 191, name: $translate.instant("COUNTRIES.SA") }, { id: 192, name: $translate.instant("COUNTRIES.SN") }, { id: 193, name: $translate.instant("COUNTRIES.CS") }, { id: 194, name: $translate.instant("COUNTRIES.SC") }, { id: 195, name: $translate.instant("COUNTRIES.SL") }, { id: 196, name: $translate.instant("COUNTRIES.SG") }, { id: 197, name: $translate.instant("COUNTRIES.SK") }, { id: 198, name: $translate.instant("COUNTRIES.SI") }, { id: 199, name: $translate.instant("COUNTRIES.SB") }, { id: 200, name: $translate.instant("COUNTRIES.SO") }, { id: 201, name: $translate.instant("COUNTRIES.ZA") }, { id: 202, name: $translate.instant("COUNTRIES.GS") }, { id: 203, name: $translate.instant("COUNTRIES.ES") }, { id: 204, name: $translate.instant("COUNTRIES.LK") }, { id: 205, name: $translate.instant("COUNTRIES.SD") }, { id: 206, name: $translate.instant("COUNTRIES.SR") }, { id: 207, name: $translate.instant("COUNTRIES.SJ") }, { id: 208, name: $translate.instant("COUNTRIES.SZ") }, { id: 209, name: $translate.instant("COUNTRIES.SE") }, { id: 210, name: $translate.instant("COUNTRIES.CH") }, { id: 211, name: $translate.instant("COUNTRIES.SY") }, { id: 212, name: $translate.instant("COUNTRIES.TW") }, { id: 213, name: $translate.instant("COUNTRIES.TJ") }, { id: 214, name: $translate.instant("COUNTRIES.TZ") }, { id: 215, name: $translate.instant("COUNTRIES.TH") }, { id: 216, name: $translate.instant("COUNTRIES.TL") }, { id: 217, name: $translate.instant("COUNTRIES.TG") }, { id: 218, name: $translate.instant("COUNTRIES.TK") }, { id: 219, name: $translate.instant("COUNTRIES.TO") }, { id: 220, name: $translate.instant("COUNTRIES.TT") }, { id: 221, name: $translate.instant("COUNTRIES.TN") }, { id: 222, name: $translate.instant("COUNTRIES.TR") }, { id: 223, name: $translate.instant("COUNTRIES.TM") }, { id: 224, name: $translate.instant("COUNTRIES.TC") }, { id: 225, name: $translate.instant("COUNTRIES.TV") }, { id: 226, name: $translate.instant("COUNTRIES.UG") }, { id: 227, name: $translate.instant("COUNTRIES.UA") }, { id: 228, name: $translate.instant("COUNTRIES.AE") }, { id: 229, name: $translate.instant("COUNTRIES.GB") }, { id: 230, name: $translate.instant("COUNTRIES.US") }, { id: 231, name: $translate.instant("COUNTRIES.UM") }, { id: 232, name: $translate.instant("COUNTRIES.UY") }, { id: 233, name: $translate.instant("COUNTRIES.UZ") }, { id: 234, name: $translate.instant("COUNTRIES.VU") }, { id: 235, name: $translate.instant("COUNTRIES.VE") }, { id: 236, name: $translate.instant("COUNTRIES.VN") }, { id: 237, name: $translate.instant("COUNTRIES.VG") }, { id: 238, name: $translate.instant("COUNTRIES.VI") }, { id: 239, name: $translate.instant("COUNTRIES.WF") }, { id: 240, name: $translate.instant("COUNTRIES.EH") }, { id: 241, name: $translate.instant("COUNTRIES.YE") }, { id: 242, name: $translate.instant("COUNTRIES.ZM") }, { id: 243, name: $translate.instant("COUNTRIES.ZW") }],
    selectPortfolioImage: function selectPortfolioImage(portfolio) {
      cov_2bpe87ftbo.s[16]++;

      this.selectedPortfolioImage = portfolio;
    },
    loadSupPortefolio: function loadSupPortefolio() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2bpe87ftbo.b[3][0]++, { id: 0 });
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2bpe87ftbo.b[4][0]++, false);
      cov_2bpe87ftbo.s[17]++;

      if (last) {
        cov_2bpe87ftbo.b[5][0]++;
        cov_2bpe87ftbo.s[18]++;

        return;
      } else {
        cov_2bpe87ftbo.b[5][1]++;
      }
      cov_2bpe87ftbo.s[19]++;
      $state.go("index.sub-portfolio", { id: item.id });
    },
    goToProject: function goToProject(portfolio) {
      cov_2bpe87ftbo.s[20]++;

      $rootScope.homePortfolio = false;

      cov_2bpe87ftbo.s[21]++;
      $scope.view.checkLangUpdate();
      cov_2bpe87ftbo.s[22]++;
      if (!portfolio.CAN_SELECT) {
        cov_2bpe87ftbo.b[6][0]++;
        cov_2bpe87ftbo.s[23]++;

        return;
      } else {
        cov_2bpe87ftbo.b[6][1]++;
      }
      cov_2bpe87ftbo.s[24]++;
      localStorage.removeItem("gobackportfolio");
      cov_2bpe87ftbo.s[25]++;
      localStorage.setItem("PORTFOLIO_ID_KEY", portfolio.id);
      cov_2bpe87ftbo.s[26]++;
      $deltahttp.setProject(portfolio.id);

      cov_2bpe87ftbo.s[27]++;
      $state.go("index.projects");
    },
    checkLangUpdate: function checkLangUpdate() {
      cov_2bpe87ftbo.s[28]++;

      $CRUDService.getAll('Connexion', { get: "translateState" }, function (response) {
        cov_2bpe87ftbo.f[2]++;
        cov_2bpe87ftbo.s[29]++;

        $log.log('DELTA_TRANSLATE =' + response);
        cov_2bpe87ftbo.s[30]++;
        if (window.localStorage) {
          cov_2bpe87ftbo.b[7][0]++;
          cov_2bpe87ftbo.s[31]++;

          if (response == '2') {
            cov_2bpe87ftbo.b[8][0]++;
            cov_2bpe87ftbo.s[32]++;

            localStorage.removeItem('TRANSLATE_fr');
            cov_2bpe87ftbo.s[33]++;
            localStorage.removeItem('TRANSLATE_en');
            cov_2bpe87ftbo.s[34]++;
            localStorage.removeItem('TRANSLATE_ar');
            cov_2bpe87ftbo.s[35]++;
            localStorage.removeItem('TRANSLATE_es');
            cov_2bpe87ftbo.s[36]++;
            localStorage.removeItem('TRANSLATE_pt');
          } else {
            cov_2bpe87ftbo.b[8][1]++;
          }
          cov_2bpe87ftbo.s[37]++;
          if ((cov_2bpe87ftbo.b[10][0]++, response == '2') || (cov_2bpe87ftbo.b[10][1]++, response == '1')) {
            cov_2bpe87ftbo.b[9][0]++;
            cov_2bpe87ftbo.s[38]++;

            localStorage.removeItem('DELTA_TRANSLATE');
          } else {
            cov_2bpe87ftbo.b[9][1]++;
            cov_2bpe87ftbo.s[39]++;

            localStorage.setItem('DELTA_TRANSLATE', parseInt(response));
          }
        } else {
          cov_2bpe87ftbo.b[7][1]++;
        }
      });
    },
    buildTree: function buildTree() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2bpe87ftbo.b[11][0]++, []);

      var root = (cov_2bpe87ftbo.s[40]++, { children: [], id: 0 });
      var mapping = (cov_2bpe87ftbo.s[41]++, {});
      cov_2bpe87ftbo.s[42]++;
      if (angular.isArray(data)) {
        cov_2bpe87ftbo.b[12][0]++;
        cov_2bpe87ftbo.s[43]++;

        data.sort(function (first, second) {
          cov_2bpe87ftbo.f[3]++;
          cov_2bpe87ftbo.s[44]++;

          return first.ID_PARENT.toString() > second.ID_PARENT.toString() ? (cov_2bpe87ftbo.b[13][0]++, 1) : (cov_2bpe87ftbo.b[13][1]++, -1);
        });

        cov_2bpe87ftbo.s[45]++;
        data.forEach(function (portfolio) {
          cov_2bpe87ftbo.f[4]++;
          cov_2bpe87ftbo.s[46]++;

          mapping[portfolio.id] = portfolio;
        });

        cov_2bpe87ftbo.s[47]++;
        data.forEach(function (portfolio) {
          cov_2bpe87ftbo.f[5]++;

          var parent = (cov_2bpe87ftbo.s[48]++, mapping[portfolio.ID_PARENT]);

          cov_2bpe87ftbo.s[49]++;
          if (parent) {
            cov_2bpe87ftbo.b[14][0]++;
            cov_2bpe87ftbo.s[50]++;

            portfolio.custom_id = parent.custom_id + "_" + portfolio.id;
            cov_2bpe87ftbo.s[51]++;
            parent.hasChild = true;
          } else {
            cov_2bpe87ftbo.b[14][1]++;
            cov_2bpe87ftbo.s[52]++;

            portfolio.custom_id = "0_" + portfolio.id;
          }

          cov_2bpe87ftbo.s[53]++;
          portfolio.level = portfolio.custom_id.split("_").length - 1;
        });
      } else {
        cov_2bpe87ftbo.b[12][1]++;
      }

      cov_2bpe87ftbo.s[54]++;
      return data;
    },
    addItem: function addItem() {
      var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2bpe87ftbo.b[15][0]++, null);

      var date = (cov_2bpe87ftbo.s[55]++, Date.newDate());
      cov_2bpe87ftbo.s[56]++;
      date.setMonth(date.getMonth() + 120);
      cov_2bpe87ftbo.s[57]++;
      this.editItem({
        ID_PARENT: (cov_2bpe87ftbo.b[16][0]++, parent == null ? (cov_2bpe87ftbo.b[17][0]++, 0) : (cov_2bpe87ftbo.b[17][1]++, parent.id)) || (cov_2bpe87ftbo.b[16][1]++, 0),
        ID_PROGRAM: 0,
        PORTFOLIO: 1,
        ADR_PROJET: "",
        AG_EXE_PROJET: "",
        CODE_ESPACE: "",
        CODE_PRJ: "",
        DATE_DEB_PROJET: Date.newDate(),
        DATE_FIN_PROJET: date,
        DESCRIPTION_PROJET: "",
        Format_cout: "",
        ID_LOG_FRAME: 0,
        LIBELLE_PROJET: "",
        PAYS_PROJET: 230,
        LINK_PG: 0,
        FAX_PROJET: "",
        EMAIL_PROJET: "",
        TEL_PROJET: "",
        id: 0,
        OBJECTIF: "",
        INDICATOR_FIELD_1: "",
        INDICATOR_FIELD_2: "",
        CIBLE: "",
        ZONE: "",
        STATUT: 0,
        STATUS: 2,
        DATE_MI_PRO: Date.newDate(),
        FINAN: "",
        COUT: 0,
        IDS_AGENCY: [],
        STATUT_BUDGET: 0,
        ID_AGENCY: 0,
        CROSS_CUTTING_KPIS: 0,
        PORTFOLIO_CROSS_CUTTING_KPIS: 1,
        CUSTOM_FIELD: 0,
        MISSIONS: 0,
        RISK: 0,
        PROBLEM: 0,
        ACTIVE_SMS: 0,
        LINK: {
          U: 0,
          SF: 0,
          PG: 0,
          PL: 0,
          F: 0,
          TA: 0,
          TI: 0,
          TR: 0,
          FR: 0
        },
        PERIODIC_FOLLOW: "12",
        ME_METHOD: "0",
        START_MONTH: "1",
        GLOBAL_PLAN: 0,
        ACTIVITY_WEIGHT: 0,
        DISPLAY_DATA: 0 });
    },
    editItem: function editItem(item) {
      cov_2bpe87ftbo.s[58]++;


      this.selectedItem = angular.copy(item);
      cov_2bpe87ftbo.s[59]++;
      this.selectedItem.CHAMP_LIBRE = item.CHAMP_LIBRE == "1";
      cov_2bpe87ftbo.s[60]++;
      this.selectedItem.LABEL_FIELD_1 = item.LABEL_FIELD_1;
      cov_2bpe87ftbo.s[61]++;
      this.selectedItem.LABEL_FIELD_2 = item.LABEL_FIELD_2;
      cov_2bpe87ftbo.s[62]++;
      this.selectedItem.OPTIONS_FIXES = item.OPTIONS_FIXES == "1";
      cov_2bpe87ftbo.s[63]++;
      console.log("editItem", this.selectedItem);
      cov_2bpe87ftbo.s[64]++;

      this.selectedItem.PAYS_PROJET = (cov_2bpe87ftbo.b[18][0]++, this.contries.find(function (p) {
        cov_2bpe87ftbo.f[6]++;
        cov_2bpe87ftbo.s[65]++;
        return p.id == item.PAYS_PROJET;
      })) || (cov_2bpe87ftbo.b[18][1]++, { id: 0 });

      cov_2bpe87ftbo.s[66]++;

      $CRUDService.getAll('CategoryPersonnaliseA', { get: 'all', projectId: item.id }, function (data) {
        cov_2bpe87ftbo.f[7]++;
        cov_2bpe87ftbo.s[67]++;

        console.log("Structure données : ", data);
        cov_2bpe87ftbo.s[68]++;
        $scope.categoryPers_A = data;
      });

      cov_2bpe87ftbo.s[69]++;
      $CRUDService.getAll('CategoryPersonnaliseB', { get: 'all', projectId: item.id }, function (data) {
        cov_2bpe87ftbo.f[8]++;
        cov_2bpe87ftbo.s[70]++;

        $scope.categoryPers_B = data;
      });

      cov_2bpe87ftbo.s[71]++;
      $uibModal.open({
        templateUrl: "app/views/portfolio/edit/description.html",
        controller: portfolioCtrl_edit,
        scope: $scope,
        size: "xs",
        backdrop: "static",
        windowClass: "animated fadeInRight left-modal"
      });
    },
    getAll: function getAll() {
      var _this = this;

      cov_2bpe87ftbo.s[72]++;


      this.loading = true;
      var status = (cov_2bpe87ftbo.s[73]++, ((cov_2bpe87ftbo.b[19][0]++, localStorage.getItem("gobackportfolio")) || (cov_2bpe87ftbo.b[19][1]++, null)) == null);
      cov_2bpe87ftbo.s[74]++;

      $CRUDService.getAll(PATH, { get: "user_portfolio", id: -1 }, function (data_) {
        cov_2bpe87ftbo.f[9]++;

        var data = (cov_2bpe87ftbo.s[75]++, _this.buildTree(data_));cov_2bpe87ftbo.s[76]++;


        _this.portfolios = data.map(function (project) {
          cov_2bpe87ftbo.f[10]++;
          cov_2bpe87ftbo.s[77]++;

          project.img = $deltahttp.getProjectRepository(project.id, $scope.view.currentDate);
          cov_2bpe87ftbo.s[78]++;
          project.DATE_DEB_PROJET = Date.newDate(project.DATE_DEB_PROJET);
          cov_2bpe87ftbo.s[79]++;
          project.DATE_FIN_PROJET = Date.newDate(project.DATE_FIN_PROJET);
          cov_2bpe87ftbo.s[80]++;
          project.DATE_MI_PRO = Date.newDate(project.DATE_MI_PRO);
          cov_2bpe87ftbo.s[81]++;
          return project;
        });

        var rightsPortfolio = (cov_2bpe87ftbo.s[82]++, _this.portfolios.filter(function (item) {
          cov_2bpe87ftbo.f[11]++;
          cov_2bpe87ftbo.s[83]++;

          return item.CAN_SELECT;
        }));
        cov_2bpe87ftbo.s[84]++;
        $rootScope.setfirstDisplay();
        var checkGoTo = (cov_2bpe87ftbo.s[85]++, (cov_2bpe87ftbo.b[20][0]++, rightsPortfolio.length == 1) && (cov_2bpe87ftbo.b[20][1]++, !$rootScope.connectedUser.superAdmin) || (cov_2bpe87ftbo.b[20][2]++, rightsPortfolio.length > 0) && (cov_2bpe87ftbo.b[20][3]++, !$rootScope.connectedUser.multi));
        cov_2bpe87ftbo.s[86]++;
        if ((cov_2bpe87ftbo.b[22][0]++, checkGoTo) && (cov_2bpe87ftbo.b[22][1]++, !$rootScope.connectedUser.autoRedirected)) {
          cov_2bpe87ftbo.b[21][0]++;
          cov_2bpe87ftbo.s[87]++;

          $rootScope.connectedUser.autoRedirected = true;
          cov_2bpe87ftbo.s[88]++;
          _this.goToProject((cov_2bpe87ftbo.b[23][0]++, rightsPortfolio[0]) || (cov_2bpe87ftbo.b[23][1]++, { id: 0 }));
          cov_2bpe87ftbo.s[89]++;
          return;
        } else {
          cov_2bpe87ftbo.b[21][1]++;
        }
        cov_2bpe87ftbo.s[90]++;
        _this.loading = false;
      });
    },
    parents: function parents() {
      var _this2 = this;

      cov_2bpe87ftbo.s[91]++;

      $CRUDService.getAll(PATH, { get: "parents", id: (cov_2bpe87ftbo.b[24][0]++, ((cov_2bpe87ftbo.b[25][0]++, $stateParams) || (cov_2bpe87ftbo.b[25][1]++, { id: 0 })).id) || (cov_2bpe87ftbo.b[24][1]++, 0) }, function (data) {
        cov_2bpe87ftbo.f[12]++;
        cov_2bpe87ftbo.s[92]++;

        _this2.historic = data;
      });
    },
    saveItem: function saveItem() {},
    deleteItem: function deleteItem(validateItem) {
      cov_2bpe87ftbo.s[93]++;

      SweetAlert.swal({
        title: $translate.instant("COMMON.CONFIRM"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#c8c8c8",
        confirmButtonText: $translate.instant("COMMON.NO"),
        cancelButtonText: $translate.instant("COMMON.YES"),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_2bpe87ftbo.f[13]++;
        cov_2bpe87ftbo.s[94]++;

        if (isconfirm) {
          cov_2bpe87ftbo.b[26][0]++;
          cov_2bpe87ftbo.s[95]++;

          return;
        } else {
          cov_2bpe87ftbo.b[26][1]++;
        }
        cov_2bpe87ftbo.s[96]++;
        $scope.isloading = true;
        cov_2bpe87ftbo.s[97]++;
        $CRUDService.delet(PATH, { action: "supp_definitif_portfolio", id: validateItem.id }, function (data) {
          cov_2bpe87ftbo.f[14]++;
          cov_2bpe87ftbo.s[98]++;

          if (data < 0) {
            cov_2bpe87ftbo.b[27][0]++;
            cov_2bpe87ftbo.s[99]++;

            SweetAlert.swal({
              title: $translate.instant("COMMON.ERROR_DELETE"),
              text: $translate.instant("PROJECT.ERROR.DELETE")
            });
            cov_2bpe87ftbo.s[100]++;
            $scope.isloading = false;
            cov_2bpe87ftbo.s[101]++;
            return;
          } else {
            cov_2bpe87ftbo.b[27][1]++;
          }
          cov_2bpe87ftbo.s[102]++;
          $scope.view.getAll();
        });
      });
    },
    openItem: function openItem(item) {
      cov_2bpe87ftbo.s[103]++;

      this.historic.push(item);
      cov_2bpe87ftbo.s[104]++;
      this.getAll(item.id);
    },
    goBack: function goBack() {
      cov_2bpe87ftbo.s[105]++;

      this.historic.pop();
      cov_2bpe87ftbo.s[106]++;
      this.getAll(this.historic.pop());
    }
  };

  var uploader = (cov_2bpe87ftbo.s[107]++, $scope.uploader = new FileUploader({
    headers: $CRUDService.getHeader(),
    url: $CRUDService.getServerAdress() + "web_server.php?action=img&method=1&" + $CRUDService.getComplement() + "&li_bksb=" + PATH,
    alias: "fileformatrapp",
    removeAfterUpload: true
  }));

  cov_2bpe87ftbo.s[108]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_2bpe87ftbo.f[15]++;
    cov_2bpe87ftbo.s[109]++;

    fileItem.url = uploader.url + "&id=" + $scope.view.selectedPortfolioImage.id;
    cov_2bpe87ftbo.s[110]++;
    $scope.isloading = true;
    cov_2bpe87ftbo.s[111]++;
    fileItem.upload();
  };

  cov_2bpe87ftbo.s[112]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_2bpe87ftbo.f[16]++;
    cov_2bpe87ftbo.s[113]++;

    $scope.view.currentDate = new Date();
    cov_2bpe87ftbo.s[114]++;
    for (var _iterator2 = $scope.view.portfolios, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var el = _ref2;
      cov_2bpe87ftbo.s[115]++;

      if (el.id == $scope.view.selectedPortfolioImage.id) {
        cov_2bpe87ftbo.b[28][0]++;
        cov_2bpe87ftbo.s[116]++;

        el.img = $deltahttp.getProjectRepository(el.id, $scope.view.currentDate);
        cov_2bpe87ftbo.s[117]++;
        break;
      } else {
        cov_2bpe87ftbo.b[28][1]++;
      }
    }
    cov_2bpe87ftbo.s[118]++;
    $scope.view.selectedPortfolioImage = null;
    cov_2bpe87ftbo.s[119]++;
    $scope.isloading = false;
  };

  cov_2bpe87ftbo.s[120]++;
  $scope.updateCatPersA = function (item, deleteItem) {
    cov_2bpe87ftbo.f[17]++;
    cov_2bpe87ftbo.s[121]++;

    $scope.categoryPers_A = (cov_2bpe87ftbo.b[29][0]++, $scope.categoryPers_A) || (cov_2bpe87ftbo.b[29][1]++, []);
    cov_2bpe87ftbo.s[122]++;
    if (deleteItem) {
      cov_2bpe87ftbo.b[30][0]++;
      cov_2bpe87ftbo.s[123]++;

      $scope.categoryPers_A = $scope.categoryPers_A.filter(function (categoryPers) {
        cov_2bpe87ftbo.f[18]++;
        cov_2bpe87ftbo.s[124]++;

        return categoryPers.id != item.id;
      });
      cov_2bpe87ftbo.s[125]++;
      return;
    } else {
      cov_2bpe87ftbo.b[30][1]++;
    }
    cov_2bpe87ftbo.s[126]++;
    for (var _iterator3 = $scope.categoryPers_A, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var categoryPers = _ref3;
      cov_2bpe87ftbo.s[127]++;

      if (categoryPers.id == item.id) {
        cov_2bpe87ftbo.b[31][0]++;
        cov_2bpe87ftbo.s[128]++;

        categoryPers.NAME = item.NAME;
        cov_2bpe87ftbo.s[129]++;
        categoryPers.COLOR = item.COLOR;
        cov_2bpe87ftbo.s[130]++;
        return;
      } else {
        cov_2bpe87ftbo.b[31][1]++;
      }
    }
    cov_2bpe87ftbo.s[131]++;
    $scope.categoryPers_A.push(item);
  };

  cov_2bpe87ftbo.s[132]++;
  $scope.updateCatPersB = function (item, deleteItem) {
    cov_2bpe87ftbo.f[19]++;
    cov_2bpe87ftbo.s[133]++;

    $scope.categoryPers_B = (cov_2bpe87ftbo.b[32][0]++, $scope.categoryPers_B) || (cov_2bpe87ftbo.b[32][1]++, []);
    cov_2bpe87ftbo.s[134]++;
    if (deleteItem) {
      cov_2bpe87ftbo.b[33][0]++;
      cov_2bpe87ftbo.s[135]++;

      $scope.categoryPers_B = $scope.categoryPers_B.filter(function (categoryPers) {
        cov_2bpe87ftbo.f[20]++;
        cov_2bpe87ftbo.s[136]++;

        return categoryPers.id != item.id;
      });
      cov_2bpe87ftbo.s[137]++;
      return;
    } else {
      cov_2bpe87ftbo.b[33][1]++;
    }
    cov_2bpe87ftbo.s[138]++;
    for (var _iterator4 = $scope.categoryPers_B, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var categoryPers = _ref4;
      cov_2bpe87ftbo.s[139]++;

      if (categoryPers.id == item.id) {
        cov_2bpe87ftbo.b[34][0]++;
        cov_2bpe87ftbo.s[140]++;

        categoryPers.NAME = item.NAME;
        cov_2bpe87ftbo.s[141]++;
        categoryPers.COLOR = item.COLOR;
        cov_2bpe87ftbo.s[142]++;
        return;
      } else {
        cov_2bpe87ftbo.b[34][1]++;
      }
    }
    cov_2bpe87ftbo.s[143]++;
    $scope.categoryPers_B.push(item);
  };

  cov_2bpe87ftbo.s[144]++;

  $scope.openPersonalize_1 = function () {
    cov_2bpe87ftbo.f[21]++;
    cov_2bpe87ftbo.s[145]++;

    $uibModal.open({
      templateUrl: 'app/views/portfolio/edit/first_customed_category.html',
      controller: Personnalize_1_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_2bpe87ftbo.s[146]++;
  $scope.openPersonalize_2 = function () {
    cov_2bpe87ftbo.f[22]++;
    cov_2bpe87ftbo.s[147]++;

    $uibModal.open({
      templateUrl: 'app/views/portfolio/edit/second_customed_category.html',
      controller: Personnalize_2_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_2bpe87ftbo.s[148]++;
  $scope.view.getAll();
});

function portfolioCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService, $deltadate, $translate, $log) {
  cov_2bpe87ftbo.f[23]++;

  var PATH = (cov_2bpe87ftbo.s[149]++, "Projet");

  cov_2bpe87ftbo.s[150]++;
  $scope.autoCompleteGroupOptions = null;
  cov_2bpe87ftbo.s[151]++;
  $CRUDService.getAll(PATH, { get: "devises" }, function (_data) {
    cov_2bpe87ftbo.f[24]++;
    cov_2bpe87ftbo.s[152]++;

    $scope.autoCompleteGroupOptions = {
      minimumChars: 0,
      containerCssClass: "white-bg",
      selectedCssClass: "selected-item-auto-complete",
      noMatchTemplateEnabled: false,
      activateOnFocus: true,
      data: function data(searchText) {
        cov_2bpe87ftbo.s[153]++;

        return _data;
      }
    };
  });

  cov_2bpe87ftbo.s[154]++;
  $scope.dateLimit = {};

  cov_2bpe87ftbo.s[155]++;
  $CRUDService.getAll(PATH, {
    get: "portfolio_limit",
    id: (cov_2bpe87ftbo.b[35][0]++, $scope.view.selectedItem.id) || (cov_2bpe87ftbo.b[35][1]++, 0),
    parent: $scope.view.selectedItem.ID_PARENT
  }, function (data) {
    cov_2bpe87ftbo.f[25]++;
    cov_2bpe87ftbo.s[156]++;

    if (data.min) {
      cov_2bpe87ftbo.b[36][0]++;
      cov_2bpe87ftbo.s[157]++;

      data.min.begin = Date.newDate(data.min.begin);
      cov_2bpe87ftbo.s[158]++;
      data.min.end = Date.newDate(data.min.end);
      cov_2bpe87ftbo.s[159]++;
      data.min.begin_str = $deltadate.format(data.min.begin, "yyyy-mm-dd");
      cov_2bpe87ftbo.s[160]++;
      data.min.end_str = $deltadate.format(data.min.end, "yyyy-mm-dd");
    } else {
      cov_2bpe87ftbo.b[36][1]++;
    }

    cov_2bpe87ftbo.s[161]++;
    if (data.max) {
      cov_2bpe87ftbo.b[37][0]++;
      cov_2bpe87ftbo.s[162]++;

      data.max.begin = Date.newDate(data.max.begin);
      cov_2bpe87ftbo.s[163]++;
      data.max.end = Date.newDate(data.max.end);
      cov_2bpe87ftbo.s[164]++;
      data.max.begin_str = $deltadate.format(data.max.begin, "yyyy-mm-dd");
      cov_2bpe87ftbo.s[165]++;
      data.max.end_str = $deltadate.format(data.max.end, "yyyy-mm-dd");
    } else {
      cov_2bpe87ftbo.b[37][1]++;
    }

    cov_2bpe87ftbo.s[166]++;
    $scope.dateLimit = data;
  });

  cov_2bpe87ftbo.s[167]++;
  $scope.setValidData = function () {
    cov_2bpe87ftbo.f[26]++;
    cov_2bpe87ftbo.s[168]++;

    $scope.error = { dateLimit: [] };
    var item = (cov_2bpe87ftbo.s[169]++, angular.copy($scope.view.selectedItem));

    cov_2bpe87ftbo.s[170]++;
    item.CODE_PRJ = item.CODE_PRJ.toString().trim().toUpperCase();
    var items = (cov_2bpe87ftbo.s[171]++, $scope.view.portfolios.filter(function (it) {
      cov_2bpe87ftbo.f[27]++;
      cov_2bpe87ftbo.s[172]++;

      return (cov_2bpe87ftbo.b[38][0]++, it.CODE_PRJ.toUpperCase() === item.CODE_PRJ) && (cov_2bpe87ftbo.b[38][1]++, it.id != item.id);
    }));

    cov_2bpe87ftbo.s[173]++;
    if (items.length > 0) {
      cov_2bpe87ftbo.b[39][0]++;
      cov_2bpe87ftbo.s[174]++;

      $scope.error.double = true;
      cov_2bpe87ftbo.s[175]++;
      return;
    } else {
      cov_2bpe87ftbo.b[39][1]++;
    }

    cov_2bpe87ftbo.s[176]++;

    item.DATE_DEB_PROJET = $deltadate.format(item.DATE_DEB_PROJET, "dd/mm/yyyy");
    cov_2bpe87ftbo.s[177]++;
    item.DATE_FIN_PROJET = $deltadate.format(item.DATE_FIN_PROJET, "dd/mm/yyyy");
    cov_2bpe87ftbo.s[178]++;
    item.DATE_MI_PRO = $deltadate.format(new Date(), "yyyy-mm-dd");
    cov_2bpe87ftbo.s[179]++;
    item.PAYS_PROJET = item.PAYS_PROJET.id;
    cov_2bpe87ftbo.s[180]++;
    item.CHAMP_LIBRE = $scope.view.selectedItem.CHAMP_LIBRE;
    cov_2bpe87ftbo.s[181]++;
    item.LABEL_FIELD_1 = $scope.view.selectedItem.LABEL_FIELD_1;
    cov_2bpe87ftbo.s[182]++;
    item.LABEL_FIELD_2 = $scope.view.selectedItem.LABEL_FIELD_2;
    cov_2bpe87ftbo.s[183]++;
    item.OPTIONS_FIXES = $scope.view.selectedItem.OPTIONS_FIXES;
    cov_2bpe87ftbo.s[184]++;
    $CRUDService.save(PATH, { action: "miseAJourAdmin", valeur: item }, function (value) {
      cov_2bpe87ftbo.f[28]++;
      cov_2bpe87ftbo.s[185]++;

      $scope.view.getAll();
      cov_2bpe87ftbo.s[186]++;
      $scope.closeModal();
    });
  };
  cov_2bpe87ftbo.s[187]++;
  $scope.closeModal = function () {
    cov_2bpe87ftbo.f[29]++;
    cov_2bpe87ftbo.s[188]++;

    $uibModalInstance.dismiss("cancel");
  };
}

function Personnalize_1_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_2bpe87ftbo.f[30]++;
  cov_2bpe87ftbo.s[189]++;

  $scope.addCategory = function () {
    cov_2bpe87ftbo.f[31]++;
    cov_2bpe87ftbo.s[190]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_2bpe87ftbo.s[191]++;
  $scope.editCategory = function (item) {
    cov_2bpe87ftbo.f[32]++;
    cov_2bpe87ftbo.s[192]++;

    $scope.error_code = {};
    cov_2bpe87ftbo.s[193]++;
    $scope.selectedCatPersA = angular.copy(item);
  };

  cov_2bpe87ftbo.s[194]++;
  $scope.cancelCategory = function () {
    cov_2bpe87ftbo.f[33]++;
    cov_2bpe87ftbo.s[195]++;

    $scope.selectedCatPersA = null;
  };

  cov_2bpe87ftbo.s[196]++;
  $scope.validateCategory = function () {
    cov_2bpe87ftbo.f[34]++;
    cov_2bpe87ftbo.s[197]++;

    $scope.error_code = {};
    cov_2bpe87ftbo.s[198]++;
    $scope.categoryPers_A = [];
    cov_2bpe87ftbo.s[199]++;

    if ((cov_2bpe87ftbo.b[41][0]++, !$scope.categoryPers_A) || (cov_2bpe87ftbo.b[41][1]++, !Array.isArray($scope.categoryPers_A))) {
      cov_2bpe87ftbo.b[40][0]++;
      cov_2bpe87ftbo.s[200]++;

      console.warn('categoryPers_A n\'est pas un tableau valide:', $scope.categoryPers_A);
      cov_2bpe87ftbo.s[201]++;

      $scope.categoryPers_A = [];
    } else {
      cov_2bpe87ftbo.b[40][1]++;
    }

    cov_2bpe87ftbo.s[202]++;

    if ((cov_2bpe87ftbo.b[43][0]++, !$scope.selectedCatPersA) || (cov_2bpe87ftbo.b[43][1]++, !$scope.selectedCatPersA.NAME)) {
      cov_2bpe87ftbo.b[42][0]++;
      cov_2bpe87ftbo.s[203]++;

      $scope.error_code.name = true;
      cov_2bpe87ftbo.s[204]++;
      return;
    } else {
      cov_2bpe87ftbo.b[42][1]++;
    }

    cov_2bpe87ftbo.s[205]++;

    if ($scope.categoryPers_A.filter(function (category) {
      cov_2bpe87ftbo.f[35]++;
      cov_2bpe87ftbo.s[206]++;

      return (cov_2bpe87ftbo.b[45][0]++, $scope.selectedCatPersA.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_2bpe87ftbo.b[45][1]++, category.id != $scope.selectedCatPersA.id);
    }).length > 0) {
      cov_2bpe87ftbo.b[44][0]++;
      cov_2bpe87ftbo.s[207]++;

      $scope.error_code.name = true;
      cov_2bpe87ftbo.s[208]++;
      return;
    } else {
      cov_2bpe87ftbo.b[44][1]++;
    }

    cov_2bpe87ftbo.s[209]++;
    $CRUDService.save('CategoryPersonnaliseA', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersA)
    }, function (data) {
      cov_2bpe87ftbo.f[36]++;
      cov_2bpe87ftbo.s[210]++;

      $scope.selectedCatPersA.id = String(parseInt(data, 10));
      cov_2bpe87ftbo.s[211]++;
      $scope.updateCatPersA(angular.copy($scope.selectedCatPersA));
      cov_2bpe87ftbo.s[212]++;
      $scope.selectedCatPersA = null;
    });
  };

  cov_2bpe87ftbo.s[213]++;
  $scope.deleteCategory = function (item) {
    cov_2bpe87ftbo.f[37]++;
    cov_2bpe87ftbo.s[214]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2bpe87ftbo.f[38]++;
      cov_2bpe87ftbo.s[215]++;

      if (isconfirm) {
        cov_2bpe87ftbo.b[46][0]++;
        cov_2bpe87ftbo.s[216]++;

        return;
      } else {
        cov_2bpe87ftbo.b[46][1]++;
      }
      cov_2bpe87ftbo.s[217]++;
      $scope.isloading = true;
      var validateItem = (cov_2bpe87ftbo.s[218]++, {
        id: item.id
      });
      cov_2bpe87ftbo.s[219]++;
      $CRUDService.delet('CategoryPersonnaliseA', { action: 'supp', id: item.id }, function (data) {
        cov_2bpe87ftbo.f[39]++;
        cov_2bpe87ftbo.s[220]++;

        if (data < 0) {
          cov_2bpe87ftbo.b[47][0]++;
          cov_2bpe87ftbo.s[221]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_2bpe87ftbo.s[222]++;
          $scope.isloading = false;
          cov_2bpe87ftbo.s[223]++;
          return;
        } else {
          cov_2bpe87ftbo.b[47][1]++;
        }
        cov_2bpe87ftbo.s[224]++;
        $scope.updateCatPersA({ id: validateItem.id }, true);
      });
    });
  };

  cov_2bpe87ftbo.s[225]++;
  $scope.closeModal = function () {
    cov_2bpe87ftbo.f[40]++;
    cov_2bpe87ftbo.s[226]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function Personnalize_2_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_2bpe87ftbo.f[41]++;
  cov_2bpe87ftbo.s[227]++;

  $scope.addCategory = function () {
    cov_2bpe87ftbo.f[42]++;
    cov_2bpe87ftbo.s[228]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_2bpe87ftbo.s[229]++;
  $scope.editCategory = function (item) {
    cov_2bpe87ftbo.f[43]++;
    cov_2bpe87ftbo.s[230]++;

    $scope.error_code = {};
    cov_2bpe87ftbo.s[231]++;
    $scope.selectedCatPersB = angular.copy(item);
  };

  cov_2bpe87ftbo.s[232]++;
  $scope.cancelCategory = function () {
    cov_2bpe87ftbo.f[44]++;
    cov_2bpe87ftbo.s[233]++;

    $scope.selectedCatPersB = null;
  };

  cov_2bpe87ftbo.s[234]++;


  $scope.validateCategory = function () {
    cov_2bpe87ftbo.f[45]++;
    cov_2bpe87ftbo.s[235]++;

    $scope.error_code = {};

    cov_2bpe87ftbo.s[236]++;

    if ((cov_2bpe87ftbo.b[49][0]++, !$scope.categoryPers_B) || (cov_2bpe87ftbo.b[49][1]++, !Array.isArray($scope.categoryPers_B))) {
      cov_2bpe87ftbo.b[48][0]++;
      cov_2bpe87ftbo.s[237]++;

      console.warn('categoryPers_B n\'est pas un tableau valide:', $scope.categoryPers_B);
      cov_2bpe87ftbo.s[238]++;

      $scope.categoryPers_B = [];
    } else {
      cov_2bpe87ftbo.b[48][1]++;
    }

    cov_2bpe87ftbo.s[239]++;

    if ((cov_2bpe87ftbo.b[51][0]++, !$scope.selectedCatPersB) || (cov_2bpe87ftbo.b[51][1]++, !$scope.selectedCatPersB.NAME)) {
      cov_2bpe87ftbo.b[50][0]++;
      cov_2bpe87ftbo.s[240]++;

      $scope.error_code.name = true;
      cov_2bpe87ftbo.s[241]++;
      return;
    } else {
      cov_2bpe87ftbo.b[50][1]++;
    }

    cov_2bpe87ftbo.s[242]++;

    if ($scope.categoryPers_B.filter(function (category) {
      cov_2bpe87ftbo.f[46]++;
      cov_2bpe87ftbo.s[243]++;

      return (cov_2bpe87ftbo.b[53][0]++, $scope.selectedCatPersB.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_2bpe87ftbo.b[53][1]++, category.id != $scope.selectedCatPersB.id);
    }).length > 0) {
      cov_2bpe87ftbo.b[52][0]++;
      cov_2bpe87ftbo.s[244]++;

      $scope.error_code.name = true;
      cov_2bpe87ftbo.s[245]++;
      return;
    } else {
      cov_2bpe87ftbo.b[52][1]++;
    }

    cov_2bpe87ftbo.s[246]++;
    $CRUDService.save('CategoryPersonnaliseB', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersB)
    }, function (data) {
      cov_2bpe87ftbo.f[47]++;
      cov_2bpe87ftbo.s[247]++;

      $scope.selectedCatPersB.id = String(parseInt(data, 10));
      cov_2bpe87ftbo.s[248]++;
      $scope.updateCatPersB(angular.copy($scope.selectedCatPersB));
      cov_2bpe87ftbo.s[249]++;
      $scope.selectedCatPersB = null;
    });
  };

  cov_2bpe87ftbo.s[250]++;
  $scope.deleteCategory = function (item) {
    cov_2bpe87ftbo.f[48]++;
    cov_2bpe87ftbo.s[251]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2bpe87ftbo.f[49]++;
      cov_2bpe87ftbo.s[252]++;

      if (isconfirm) {
        cov_2bpe87ftbo.b[54][0]++;
        cov_2bpe87ftbo.s[253]++;

        return;
      } else {
        cov_2bpe87ftbo.b[54][1]++;
      }
      cov_2bpe87ftbo.s[254]++;
      $scope.isloading = true;
      var validateItem = (cov_2bpe87ftbo.s[255]++, {
        id: item.id
      });
      cov_2bpe87ftbo.s[256]++;
      $CRUDService.delet('CategoryPersonnaliseB', { action: 'supp', id: item.id }, function (data) {
        cov_2bpe87ftbo.f[50]++;
        cov_2bpe87ftbo.s[257]++;

        if (data < 0) {
          cov_2bpe87ftbo.b[55][0]++;
          cov_2bpe87ftbo.s[258]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_2bpe87ftbo.s[259]++;
          $scope.isloading = false;
          cov_2bpe87ftbo.s[260]++;
          return;
        } else {
          cov_2bpe87ftbo.b[55][1]++;
        }
        cov_2bpe87ftbo.s[261]++;
        $scope.updateCatPersB({ id: validateItem.id }, true);
      });
    });
  };

  cov_2bpe87ftbo.s[262]++;
  $scope.closeModal = function () {
    cov_2bpe87ftbo.f[51]++;
    cov_2bpe87ftbo.s[263]++;

    $uibModalInstance.dismiss('cancel');
  };
}